/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Table,
  Select,
  Modal,
  Input,
  Checkbox,
  InputNumber,
  Spin,
  Button,
} from "antd";
import "./product-modal.css";
import {
  getDataWithComp,
  getAlert,
  deleteData,
} from "../../../utils/SamuiUtils";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  updateItems,
  deleteItems,
  submitItems,
  deleteItem,
  bulkUpdateByCodeMaster,
  getItemsByCodeMaster,
} from "../../../utils/services";
import SmartSelect from "../../pages/InitialData/TbSetItem/SmartSelect";
import AddColorModal from "./AddColorModal";
import AddCategoryUnitModal from "./AddCategoryUnitModal";

const mapGroups = (rows = []) =>
  rows.map((r) => ({
    id: r.Group_Id ?? r.id ?? r.ID,
    name: r.Group_Name ?? r.name ?? r.Name,
    code:
      r.Group_CodeName ??
      // r.Group_Code ??
      r.Code ??
      r.code ??
      "",
    unitId: r.Unit_Id ?? r.unitId ?? null,
    unitDefault:
      r.Unit_Default ?? r.Unit_Name ?? r.Group_Unit ?? r.Item_Unit_IN ?? "",
  }));

const getRowKey = (r) =>
  String(r.Item_Id ?? r.Item_Code ?? r.Item_Barcode ?? r.key);

const mapUnits = (rows = []) =>
  rows.map((r) => ({
    id: r.Unit_Id ?? r.id,
    name: r.Unit_Name ?? r.name,
  }));

const mapWarehouses = (rows = []) =>
  rows.map((r) => ({
    id: r.WH_Id ?? r.id,
    name: r.WH_Name ?? r.name,
  }));

const mapColours = (rows = []) =>
  rows.map((r) => ({
    id: r.Colour_Id ?? r.id,
    name: r.Colour_Name ?? r.name,
    code: r.Colour_Code ?? r.code ?? r.Colour_Name ?? "", // <— เพิ่มบรรทัดนี้
  }));

const mapSizes = (rows = []) =>
  rows
    .map((r) => ({
      id: r.Size_Id ?? r.id,
      name: r.Size_Name ?? r.name,
      code: r.Size_Code ?? r.code ?? r.Size_Name ?? "",
      line: Number(r.Size_Line ?? r.line ?? 999),
    }))
    .sort((a, b) => a.line - b.line);

const normalizeName = (name = "") =>
  name.trim().toLowerCase().replace(/\s+/g, " ");

function OptionPickerModal({
  open,
  title,
  items = [], // [{id,name}]
  selectedIds = [],
  onChange, // (ids:number[])
  onCancel,
  onOk,
  gridColumns = null, // จำนวนคอลัมน์ที่ต้องการ (null = auto)
  sortByLine = false, // ถ้า true จะเรียงตาม line property แทน name
  onAddNew = null, // ฟังก์ชันสำหรับเพิ่มรายการใหม่
}) {
  const [kw, setKw] = useState("");
  const [localIds, setLocalIds] = useState(selectedIds);

  useEffect(() => {
    if (open) {
      setKw("");
      setLocalIds(selectedIds);
    }
  }, [open, selectedIds]);

  const filtered = useMemo(() => {
    const k = kw.trim().toLowerCase();
    let result = k
      ? items.filter((x) => String(x.name).toLowerCase().includes(k))
      : items;

    // Sort by line (for sizes) or alphabetically by name
    if (sortByLine) {
      return result.sort((a, b) => (a.line ?? 999) - (b.line ?? 999));
    } else {
      return result.sort((a, b) => a.name.localeCompare(b.name, "th"));
    }
  }, [kw, items, sortByLine]);

  const allIds = filtered.map((x) => x.id);
  const allChecked =
    allIds.length > 0 && allIds.every((id) => localIds.includes(id));
  const partially = allIds.some((id) => localIds.includes(id)) && !allChecked;

  const toggleAll = (checked) => {
    if (checked) {
      const merged = Array.from(new Set([...localIds, ...allIds]));
      setLocalIds(merged);
    } else {
      const removed = localIds.filter((id) => !allIds.includes(id));
      setLocalIds(removed);
    }
  };

  const toggleOne = (id) => {
    setLocalIds((a) =>
      a.includes(id) ? a.filter((x) => x !== id) : [...a, id],
    );
  };

  const handleOk = () => {
    onChange?.(localIds);
    onOk?.();
  };

  // คำนวณจำนวน rows ที่ต้องการตาม gridColumns
  const gridStyle = useMemo(() => {
    if (!gridColumns) return {};
    const totalItems = filtered.length;
    const rowsPerColumn = Math.ceil(totalItems / gridColumns);
    return {
      gridTemplateRows: `repeat(${rowsPerColumn}, auto)`,
      gridTemplateColumns: `repeat(${gridColumns}, 100px)`,
    };
  }, [gridColumns, filtered.length]);

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      onOk={handleOk}
      width={520}
      okText="เลือก"
      cancelText="ยกเลิก"
      styles={{ zIndex: 9999 }}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            {onAddNew && (
              <button
                type="button"
                onClick={onAddNew}
                style={{
                  padding: "6px 16px",
                  borderRadius: 6,
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#218838";
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#28a745";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <PlusOutlined />
                <span>เพิ่มสีใหม่</span>
              </button>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Button onClick={onCancel}>ยกเลิก</Button>
            <Button type="primary" onClick={handleOk}>
              เลือก
            </Button>
          </div>
        </div>
      }
    >
      <div className="opm-search">
        <Input
          placeholder="ค้นหา..."
          value={kw}
          onChange={(e) => setKw(e.target.value)}
          allowClear
        />
        <label className="opm-all">
          <Checkbox
            indeterminate={partially}
            checked={allChecked}
            onChange={(e) => toggleAll(e.target.checked)}
          />
          <span style={{ whiteSpace: "nowrap" }}>เลือกทั้งหมด</span>
        </label>
      </div>

      <div className="opm-list" style={gridStyle}>
        {filtered.map((it) => (
          <label key={it.id} className="opm-item">
            <input
              type="checkbox"
              checked={localIds.includes(it.id)}
              onChange={() => toggleOne(it.id)}
            />
            <span>{it.name}</span>
          </label>
        ))}
        {filtered.length === 0 && <div className="opm-empty">ไม่พบรายการ</div>}
      </div>
    </Modal>
  );
}
const sanitizeNumeric = (raw) => {
  let s = (raw ?? "").toString().replace(/[^0-9.,]/g, "");
  const i = s.indexOf(".");
  if (i !== -1) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "");
  return s;
};

const parserStrict = (v) => sanitizeNumeric(v).replace(/,/g, "");

const formatterWithCommas = (v) => {
  if (v === null || v === undefined || v === "") return "";

  const num = Number(v);
  if (isNaN(num)) return "";

  const s = String(num);
  const [int = "", dec] = s.split(".");
  const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return dec !== undefined ? `${intFmt}.${dec}` : intFmt;
};

const onlyNumberKeyDown = (e) => {
  const { key, ctrlKey, metaKey } = e;
  if (ctrlKey || metaKey) return;

  const allowNav = new Set([
    "Backspace",
    "Delete",
    "Tab",
    "Enter",
    "Escape",
    "Home",
    "End",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
  ]);
  if (allowNav.has(key)) return;

  if (/[0-9]/.test(key)) return; // ตัวเลข
  if (key === ",") return; // คอมมา
  if (key === ".") {
    // จุดเดียวเท่านั้น

    const el = e.currentTarget;
    const v = el?.value ?? "";
    const hasDot = v.includes(".");
    if (!hasDot) return;
    // ถ้า selection ครอบจุดอยู่ อนุญาตให้แทนที่ได้
    const dotIdx = v.indexOf(".");
    const { selectionStart, selectionEnd } = el;
    const coversDot =
      typeof selectionStart === "number" &&
      typeof selectionEnd === "number" &&
      selectionStart <= dotIdx &&
      dotIdx < selectionEnd;
    if (!coversDot) e.preventDefault();
    return;
  }
  e.preventDefault();
};

// ---------- หลัก ----------
export default function ProductModal({
  open,
  setOpen,
  mode = "create",
  initialData,
  onClose,
  onSubmit,
  onDataChanged,
}) {
  const isOpen = !!open;
  const origRowsRef = useRef([]);
  const focusKeyRef = useRef(null);
  const tableWrapRef = useRef(null);
  const shortNameDirtyRef = useRef(false);
  const unitDirtyRef = useRef(false);
  const baseCodeDirtyRef = useRef(false);
  const [undeletableItemIds, setUndeletableItemIds] = useState(new Set());
  const [groups, setGroups] = useState([]);
  const [units, setUnits] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [colours, setColours] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [data, setData] = useState({
    Item_Group: "",
    Item_Short_Name: "",
    Item_Code_Master: "",
    Item_Name: "",
    Item_Name_EN: "",
    Item_Unit_IN: "",
    Item_Brand: "",
    Item_Series: "",
    Item_Cost: "",
    Item_Price: "",
    Item_PriceA: "",
    Item_PriceB: "",
    is_active: "Y",
    Item_Status: "Y",
  });

  const [whIds, setWhIds] = useState([]);
  const [selColourIds, setSelColourIds] = useState([]);
  const [selSizeIds, setSelSizeIds] = useState([]);
  const [initQty, setInitQty] = useState("");
  const [itemBaseCode, setItemBaseCode] = useState("");
  const [openColourPicker, setOpenColourPicker] = useState(false);
  const [openSizePicker, setOpenSizePicker] = useState(false);
  const [showAddCategoryUnitModal, setShowAddCategoryUnitModal] =
    useState(false);
  const [showAddColorModal, setShowAddColorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [dupInfo, setDupInfo] = useState({ open: false, conflicts: [] });
  const [dupKeys, setDupKeys] = useState(new Set());
  const originalHeaderDataRef = useRef(null); // เก็บค่าเดิมของ header เมื่อเปิด modal
  const [bulkUpdateInfo, setBulkUpdateInfo] = useState({
    open: false,
    changes: {},
    affectedItems: [],
  });
  const [scrollY, setScrollY] = useState(450);

  const rowPricesBeforeChangeRef = useRef(null);
  const headerPriceBeforeChangeRef = useRef({
    Item_Price: null,
    Item_PriceA: null,
    Item_PriceB: null,
  });

  const cellRefMap = useRef({});
  const setCellRef = (rowKey, col) => (el) => {
    if (!rowKey) return;
    if (el) cellRefMap.current[`${rowKey}-${col}`] = el;
  };
  const focusCell = (rowKey, col) => {
    const el = cellRefMap.current[`${rowKey}-${col}`];
    el?.focus?.();
  };

  const widthColumns = {
    rowNo: 50,
    code: 150,
    name: 300,
    brand: 120,
    series: 120,
    colour: 90,
    size: 90,
    status: 120,
    price1: 100,
    price2: 100,
    price3: 100,
    initQty: 100,
    cost: 100,
    delete: 100,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((s) => ({ ...s, [name]: value }));

    if (mode === "edit" && name === "Item_Name") {
      const newName = String(value ?? "").trim();
      setRows((prev) =>
        prev.map((r) => (r.__deleted ? r : { ...r, Item_Name: newName })),
      );
    }
  };

  const handlePriceBlur = (field, newValue) => {
    console.debug("🔵 handlePriceBlur called:", { field, newValue });

    if (mode !== "edit") return;

    const fieldName =
      field === "Item_Price"
        ? "Price1"
        : field === "Item_PriceA"
          ? "Price2"
          : "Price3";

    const priceLabel =
      field === "Item_Price" ? "1" : field === "Item_PriceA" ? "2" : "3";

    const oldHeaderValue = Number(
      headerPriceBeforeChangeRef.current?.[field] ?? 0,
    );
    const newHeaderValue = Number(newValue ?? 0);

    // ถ้าค่าเดิมและค่าใหม่เท่ากัน ไม่ต้องทำอะไร
    if (oldHeaderValue === newHeaderValue) return;

    // ✅ ใช้ snapshot ราคาของแถว (ก่อนเปลี่ยน) เพื่อเช็คว่าต้องถามหรือไม่
    // รูปแบบ: [{ key, value }]
    const snapshot = rowPricesBeforeChangeRef.current;
    if (!Array.isArray(snapshot) || snapshot.length === 0) return;

    // ถ้าทุกรายการมีค่าเท่ากับค่าใหม่อยู่แล้ว ก็ไม่ต้องถาม
    const hasDifferentPrices = snapshot.some(
      (x) => Number(x?.value ?? 0) !== newHeaderValue,
    );
    if (!hasDifferentPrices) return;

    // ✅ สร้างข้อความตามที่ต้องการ (รองรับขึ้นบรรทัดใหม่)
    const msg =
      `การเปลี่ยนแปลงราคา ${priceLabel} เป็น ${formatterWithCommas(
        newHeaderValue,
      )} บาท\n` +
      `จะอัพเดทราคา ${priceLabel} ในทุกรายการ (${snapshot.length} รายการ)\n\n` +
      `คุณยืนยันเปลี่ยนแปลงราคา ${priceLabel} หรือไม่?`;

    getAlert("C_DIALOG_MULTILINE", msg, (ok) => {
      if (ok) {
        setRows((prev) =>
          prev.map((r) =>
            r.__deleted ? r : { ...r, [fieldName]: newHeaderValue },
          ),
        );
        headerPriceBeforeChangeRef.current[field] = newHeaderValue;
      } else {
        setData((s) => ({ ...s, [field]: oldHeaderValue }));
        const snapMap = new Map(
          snapshot.map((x) => [String(x.key), Number(x.value ?? 0)]),
        );
        setRows((prev) =>
          prev.map((r) =>
            r.__deleted
              ? r
              : {
                  ...r,
                  [fieldName]: snapMap.get(String(r.key)) ?? r[fieldName],
                },
          ),
        );
      }
    });
  };

  const selectedColourChips = useMemo(
    () => colours.filter((c) => selColourIds.includes(c.id)).map((x) => x.name),
    [selColourIds, colours],
  );

  const selectedSizeChips = useMemo(
    () => sizes.filter((s) => selSizeIds.includes(s.id)).map((x) => x.name),
    [selSizeIds, sizes],
  );

  const selectedWarehouseNames = useMemo(
    () => warehouses.filter((w) => whIds.includes(w.id)).map((x) => x.name),
    [whIds, warehouses],
  );

  const onInitQtyCellChange = (rowKey, val) => {
    const num = Number(val || 0);
    setRows((prev) =>
      prev.map((r) =>
        r.key === rowKey ? { ...r, InitQty: num, __changed: true } : r,
      ),
    );
  };

  const columns = useMemo(() => {
    const hasRows = rows.length > 0;
    const w = (k) => widthColumns[k];
    return [
      {
        title: "#",
        dataIndex: "_row",
        width: w("rowNo"),
        align: "center",
        ...(hasRows && { fixed: "left" }),
        render: (_, __, i) => i + 1,
      },
      {
        title: "รหัส",
        dataIndex: "Item_Code",
        key: "code",
        width: w("code"),
        align: "left",
        ...(hasRows && { fixed: "left" }),
        render: (i, record) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              <span
                style={{
                  fontSize: "small",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  wordWrap: "break-word",
                  textAlign: "left",
                  width: "100%",
                }}
              >
                {i}
              </span>
              {record.__isNew && <span className="badge-new">NEW</span>}
            </div>
          );
        },
      },

      {
        title: "ชื่อไทย",
        dataIndex: "Item_Name",
        key: "name",
        width: w("name"),
        ...(hasRows && { fixed: "left" }),
        render: (_, record) => {
          // ✅ แสดง Item_Name โดยตรง (ชื่อมีสี+ไซส์อยู่แล้วจาก buildVariantRow)
          return record.Item_Name || "";
        },
      },
      {
        title: "ยี่ห้อ",
        dataIndex: "Brand",
        key: "brand",
        width: w("brand"),
        align: "center",
      },
      {
        title: "รุ่น",
        dataIndex: "Series",
        key: "series",
        width: w("series"),
        align: "center",
      },
      {
        title: "สี",
        dataIndex: "Colour",
        key: "colour",
        width: w("colour"),
        align: "center",
        ...(hasRows && { fixed: "left" }),
      },
      {
        title: "ขนาด",
        dataIndex: "Size_Name",
        key: "size",
        width: w("size"),
        align: "center",
        ...(hasRows && { fixed: "left" }),
      },
      {
        title: "สถานะ",
        dataIndex: "StatusYN",
        key: "status",
        width: w("status"),
        align: "center",
        render: (_, record) => {
          const status = record.StatusYN || "Y";
          return (
            <Select
              value={status}
              onChange={(value) =>
                setRows((prev) =>
                  prev.map((r) =>
                    r.key === record.key
                      ? {
                          ...r,
                          StatusYN: value || "Y",
                          Status: value === "Y" ? "Active" : "In-Active",
                          __changed: true,
                        }
                      : r,
                  ),
                )
              }
              options={[
                { value: "Y", label: "ใช้งาน" },
                { value: "N", label: "ไม่ใช้งาน" },
              ]}
              size="small"
              style={{ width: 110 }}
            />
          );
        },
      },

      {
        title: "ราคา 1",
        dataIndex: "Price1",
        key: "p1",
        width: w("price1"),
        align: "right",
        ...(hasRows && { fixed: "left" }),
        render: (_, record) => (
          <InputNumber
            style={{ width: 70, alignItems: "flex-end", textAlign: "right" }}
            value={record.Price1 ?? 0}
            keyboard={false}
            controls={false}
            ref={setCellRef(record.key, "Price1")}
            onChange={(v) => onPriceCellChange(record.key, "Price1", v ?? 0)}
            onFocus={selectOnFocus}
            formatter={formatterWithCommas}
            parser={parserStrict}
            onKeyDown={(e) => {
              const activeRows = rows.filter((r) => !r.__deleted);
              const idx = activeRows.findIndex((r) => r.key === record.key);

              if (e.key === "ArrowUp" && idx > 0) {
                e.preventDefault();
                focusCell(activeRows[idx - 1].key, "Price1");
                return;
              }
              if (e.key === "ArrowDown" && idx < activeRows.length - 1) {
                e.preventDefault();
                focusCell(activeRows[idx + 1].key, "Price1");
                return;
              }
              if (e.key === "ArrowRight") {
                e.preventDefault();
                focusCell(record.key, "Price2");
                return;
              }
              onlyNumberKeyDown(e);
            }}
          />
        ),
      },
      {
        title: "ราคา 2",
        dataIndex: "Price2",
        key: "p2",
        width: w("price2"),
        align: "right",
        ...(hasRows && { fixed: "left" }),
        render: (_, record) => (
          <InputNumber
            style={{ width: 70, alignItems: "flex-end", textAlign: "right" }}
            value={record.Price2 ?? 0}
            keyboard={false}
            controls={false}
            ref={setCellRef(record.key, "Price2")}
            onChange={(v) => onPriceCellChange(record.key, "Price2", v ?? 0)}
            onFocus={selectOnFocus}
            formatter={formatterWithCommas}
            parser={parserStrict}
            onKeyDown={(e) => {
              const activeRows = rows.filter((r) => !r.__deleted);
              const idx = activeRows.findIndex((r) => r.key === record.key);

              if (e.key === "ArrowLeft") {
                e.preventDefault();
                focusCell(record.key, "Price1");
                return;
              }

              if (e.key === "ArrowRight") {
                e.preventDefault();
                focusCell(record.key, "Price3");
                return;
              }

              if (e.key === "ArrowUp" && idx > 0) {
                e.preventDefault();
                focusCell(activeRows[idx - 1].key, "Price2");
                return;
              }

              if (e.key === "ArrowDown" && idx < activeRows.length - 1) {
                e.preventDefault();
                focusCell(activeRows[idx + 1].key, "Price2");
                return;
              }
              onlyNumberKeyDown(e);
            }}
          />
        ),
      },
      {
        title: "ราคา 3",
        dataIndex: "Price3",
        key: "p3",
        width: w("price3"),
        align: "right",
        render: (_, record) => (
          <InputNumber
            style={{ width: 70, alignItems: "flex-end", textAlign: "right" }}
            value={record.Price3 ?? 0}
            keyboard={false}
            controls={false}
            ref={setCellRef(record.key, "Price3")}
            onChange={(v) => onPriceCellChange(record.key, "Price3", v ?? 0)}
            onFocus={selectOnFocus}
            formatter={formatterWithCommas}
            parser={parserStrict}
            onKeyDown={(e) => {
              const activeRows = rows.filter((r) => !r.__deleted);
              const idx = activeRows.findIndex((r) => r.key === record.key);

              if (e.key === "ArrowLeft") {
                e.preventDefault();
                focusCell(record.key, "Price2");
                return;
              }

              if (e.key === "ArrowRight") {
                e.preventDefault();
                focusCell(record.key, "InitQty");
                return;
              }

              if (e.key === "ArrowUp" && idx > 0) {
                e.preventDefault();
                focusCell(activeRows[idx - 1].key, "Price3");
                return;
              }

              if (e.key === "ArrowDown" && idx < activeRows.length - 1) {
                e.preventDefault();
                focusCell(activeRows[idx + 1].key, "Price3");
                return;
              }

              onlyNumberKeyDown(e);
            }}
          />
        ),
      },
      {
        title: "จน.ตั้งต้น",
        dataIndex: "InitQty",
        key: "initEdit",
        width: w("initQty"),
        align: "right",
        render: (_, record) => {
          const isEditable = mode === "create" || record.__isNew;

          if (isEditable) {
            return (
              <InputNumber
                style={{
                  width: 70,
                  alignItems: "flex-end",
                  textAlign: "right",
                }}
                value={record.InitQty ?? 0}
                keyboard={false}
                controls={false}
                ref={setCellRef(record.key, "InitQty")}
                onClick={(e) => e.stopPropagation()}
                onChange={(v) => onInitQtyCellChange(record.key, v ?? 0)}
                onFocus={selectOnFocus}
                formatter={formatterWithCommas}
                parser={parserStrict}
                precision={0}
                min={0}
                inputMode="numeric"
                onKeyDown={(e) => {
                  const activeRows = rows.filter((r) => !r.__deleted);
                  const idx = activeRows.findIndex((r) => r.key === record.key);

                  if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    focusCell(record.key, "Price3");
                    return;
                  }
                  if (e.key === "ArrowUp" && idx > 0) {
                    e.preventDefault();
                    focusCell(activeRows[idx - 1].key, "InitQty");
                    return;
                  }
                  if (e.key === "ArrowDown" && idx < activeRows.length - 1) {
                    e.preventDefault();
                    focusCell(activeRows[idx + 1].key, "InitQty");
                    return;
                  }
                  onlyNumberKeyDown(e);
                }}
              />
            );
          }
          return (
            <span style={{ paddingRight: "8px" }}>
              {Number(record.InitQty || "").toLocaleString()}
            </span>
          );
        },
      },
      {
        title: "ต้นทุน",
        dataIndex: "Cost",
        key: "cost",
        width: w("cost"),
        align: "center",
        render: (v) => Number(v || 0).toLocaleString(),
      },

      {
        title: "ลบ",
        key: "delete",
        width: w("delete"),
        align: "center",
        ...(hasRows && { fixed: "right" }),
        render: (_, record) => {
          const isUndeletable =
            record.Item_Id && undeletableItemIds.has(String(record.Item_Id));
          const canDelete = !isUndeletable && !isLoading;

          return (
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              disabled={!canDelete}
              onClick={() => handleDeleteRow(record)}
            />
          );
        },
      },
    ];
  }, [rows, undeletableItemIds, isLoading]);

  const onPriceCellChange = (rowKey, priceField, val) => {
    const num = Number(val || 0);
    setRows((prev) =>
      prev.map((r) =>
        r.key === rowKey ? { ...r, [priceField]: num, __changed: true } : r,
      ),
    );
  };

  const buildVariantRow = ({ baseShort, colour, size, idx, whText }) => {
    console.debug("buildVariantRow data : ", initialData);
    const colorCode = colour?.code || "";
    const colorName = colour?.name || "";
    const sizeCode = size?.code || "";
    const sizeName = size?.name || "";
    const code = `${baseShort}${colorCode}${sizeCode}`;
    const statusYN = data.Item_Status || "Y";
    // ✅ Fix: Use Item_Short_Name (clean base name without color/size)
    const baseName =
      initialData?.header?.Item_Short_Name || data.Item_Short_Name || "";
    const parts = [baseName];
    if (colorName) parts.push(colorName);
    if (sizeName) parts.push(sizeName);
    const fullItemName = parts.join(" ").trim();

    return {
      key: `${code}-${idx}`,
      Item_Id: null,
      __isNew: true,
      Item_Barcode: code,
      Item_Code: code,
      Item_Name: fullItemName, // ✅ ใช้ชื่อเต็มที่บวกแล้ว
      Item_Name_EN: "",
      Unit: data.Item_Unit_IN || "",
      Item_Unit_IN: data.Item_Unit_IN || "",
      Colour: colorName,
      Size: sizeName,
      Size_Name: sizeName,
      Brand: data.Item_Brand || "",
      Series: data.Item_Series || "",
      Warehouses: whText,
      InitQty: Number(initQty || 0),
      Cost: Number(data.Item_Cost || 0),
      Price1: 0,
      Price2: 0,
      Price3: 0,
      StatusYN: statusYN,
      Status: statusYN === "Y" ? "Active" : "In-Active",
    };
  };

  const totalColumnWidth = Object.values(widthColumns).reduce(
    (sum, width) => sum + width,
    0,
  );

  function splitChanges(currentRows = []) {
    const original = Array.isArray(origRowsRef.current)
      ? origRowsRef.current
      : [];

    const normId = (v) => (v == null ? null : String(v));
    const toNum = (v) => Number(v ?? 0);
    const toStr = (v) => String(v ?? "");

    const origById = new Map(
      original
        .filter((r) => r?.Item_Id != null)
        .map((r) => [normId(r.Item_Id), r]),
    );

    const nowRows = Array.isArray(currentRows) ? currentRows : [];
    const nowActive = nowRows.filter((r) => !r?.__deleted);
    const nowDeleted = nowRows.filter((r) => r?.__deleted);

    const toInsert = [];
    const toUpdate = [];
    const toDelete = [];

    // ✅ DELETE เฉพาะแถวที่ถูก mark __deleted เท่านั้น
    for (const r of nowDeleted) {
      const id = normId(r?.Item_Id);
      if (id && origById.has(id)) toDelete.push(origById.get(id));
    }

    // ✅ INSERT / UPDATE ใช้ Item_Id เป็นหลักเท่านั้น (ไม่อิง Item_Code/key)
    for (const n of nowActive) {
      const id = normId(n?.Item_Id);

      if (!id) {
        toInsert.push(n);
        continue;
      }

      const o = origById.get(id);
      if (!o) {
        // กัน edge: มี id แต่ไม่เจอใน snapshot → treat เป็น insert แบบปลอดภัย
        toInsert.push({ ...n, Item_Id: null });
        continue;
      }

      const before = {
        InitQty: toNum(o?.InitQty ?? o?.Init_Qty),
        StatusYN: toStr(o?.StatusYN ?? o?.Item_Status ?? "Y"),
        Cost: toNum(o?.Cost ?? o?.Item_Cost),
        Price1: toNum(o?.Price1 ?? o?.Item_Price),
        Price2: toNum(o?.Price2 ?? o?.Item_PriceA),
        Price3: toNum(o?.Price3 ?? o?.Item_PriceB),
        Brand: toStr(o?.Brand ?? o?.Item_Brand),
        Series: toStr(o?.Series ?? o?.Item_Series),
        Unit: toStr(o?.Item_Unit_IN ?? o?.Unit),
        Name: toStr(o?.Item_Name),
      };

      const after = {
        InitQty: toNum(n?.InitQty ?? n?.Init_Qty),
        StatusYN: toStr(n?.StatusYN ?? n?.Item_Status ?? "Y"),
        Cost: toNum(n?.Cost ?? n?.Item_Cost),
        Price1: toNum(n?.Price1 ?? n?.Item_Price),
        Price2: toNum(n?.Price2 ?? n?.Item_PriceA),
        Price3: toNum(n?.Price3 ?? n?.Item_PriceB),
        Brand: toStr(n?.Brand ?? n?.Item_Brand),
        Series: toStr(n?.Series ?? n?.Item_Series),
        Unit: toStr(n?.Item_Unit_IN ?? n?.Unit),
        Name: toStr(n?.Item_Name),
      };

      const changed =
        before.InitQty !== after.InitQty ||
        before.StatusYN !== after.StatusYN ||
        before.Cost !== after.Cost ||
        before.Price1 !== after.Price1 ||
        before.Price2 !== after.Price2 ||
        before.Price3 !== after.Price3 ||
        before.Brand !== after.Brand ||
        before.Series !== after.Series ||
        before.Unit !== after.Unit ||
        before.Name !== after.Name;

      if (changed) toUpdate.push({ ...n, Item_Id: o.Item_Id });
    }

    // กันซ้ำ delete
    const seen = new Set();
    const dedupDelete = [];
    for (const d of toDelete) {
      const id = normId(d?.Item_Id);
      if (!id || seen.has(id)) continue;
      seen.add(id);
      dedupDelete.push(d);
    }

    return { original, toInsert, toUpdate, toDelete: dedupDelete };
  }

  const mapRowToDetail = (r, whIds) => {
    const fullName = r.Item_Name || "";
    const colour = r.Colour || r.Item_Colour || "";
    const size = r.Size_Name || r.Size || r.Item_Size || "";

    return {
      Item_Barcode: r.Item_Barcode,
      Item_Code: r.Item_Code,
      Item_Name: fullName,
      Item_Unit_IN: r.Item_Unit_IN ?? r.Unit,
      Item_Colour: colour,
      Item_Size: size,
      Item_Brand: r.Brand,
      Item_Series: r.Series || "",
      Item_Cost: r.Cost,
      Item_Price: r.Price1,
      Item_PriceA: r.Price2,
      Item_PriceB: r.Price3,
      is_active: r.StatusYN,
      Item_Status: r.StatusYN,
      Init_Qty: r.InitQty,
      WH_Ids: whIds,
    };
  };

  const buildHeader = (data, shortName, whIds, initQty, itemBaseCode) => ({
    Item_Group: data.Item_Group,
    Item_Short_Name: shortName,
    Item_Name: data.Item_Name,
    Item_Name_EN: data.Item_Name_EN,
    Item_Unit_IN: data.Item_Unit_IN,
    Item_Brand: data.Item_Brand,
    Item_Series: data.Item_Series || "",
    Item_Cost: Number(data.Item_Cost || 0),
    Item_Price: Number(data.Item_Price || 0),
    Item_PriceA: Number(data.Item_PriceA || 0),
    Item_PriceB: Number(data.Item_PriceB || 0),
    is_active: data.is_active || data.Item_Status || "Y",
    Item_Status: data.is_active || data.Item_Status || "Y",
    WH_Ids: whIds,
    Init_Qty_All: Number(initQty || 0),
    itemBaseCode,
  });

  const handleDeleteSelected = async () => {
    if (selectedRowKeys.length === 0) {
      return getAlert("FAILED", "กรุณาเลือกรายการที่จะลบ");
    }

    try {
      const selectedRows = rows.filter((x) =>
        selectedRowKeys.includes(getRowKey(x)),
      );

      const result = await deleteItems(selectedRows, {
        checkOnly: true,
        silent: true,
      });
      const { canDelete, cannotDelete } = result;
      if (cannotDelete.length > 0 && canDelete.length === 0) {
        getAlert("WARNING_LIST", {
          title: "ไม่สามารถลบสินค้าได้ เนื่องจากมีการเคลื่อนไหวสต็อกแล้ว",
          items: cannotDelete.map((r) => ({
            code: r.Item_Code,
            name: r.Item_Name,
          })),
        });
        return;
      }
      if (cannotDelete.length > 0 && canDelete.length > 0) {
        getAlert(
          "WARNING_LIST_CONFIRM",
          {
            title: "มีสินค้าบางรายการไม่สามารถลบได้",
            cannotDelete: cannotDelete.map((r) => ({
              code: r.Item_Code,
              name: r.Item_Name,
            })),
            canDelete: canDelete.map((r) => ({
              code: r.Item_Code,
              name: r.Item_Name,
            })),
            question: "คุณต้องการลบสินค้าที่เหลือหรือไม่?",
          },
          async (ok) => {
            if (!ok) return;

            try {
              for (const r of canDelete) {
                const where = `WHERE Item_Id='${r.Item_Id}'`;
                await Promise.all([
                  deleteData("Tb_Set_Item", where),
                  deleteData("WH_ITEM_STC", where),
                  deleteData("WH_ITEM_Onhand", where),
                ]);
              }
              const deletedKeys = canDelete.map((r) => getRowKey(r));
              setRows((prev) =>
                prev.filter((r) => !deletedKeys.includes(getRowKey(r))),
              );
              setSelectedRowKeys([]);
              getAlert("OK", `ลบข้อมูลสำเร็จ ${canDelete.length} รายการ`);
              await onDataChanged?.();
            } catch (e) {
              console.error(e);
              getAlert("FAILED", "ไม่สามารถลบข้อมูลได้");
            }
          },
        );
        return;
      }
      getAlert("C_DIALOG", "คุณต้องการลบรายการที่เลือกหรือไม่?", async (ok) => {
        if (!ok) return;
        try {
          for (const r of canDelete) {
            const where = `WHERE Item_Id='${r.Item_Id}'`;
            await Promise.all([
              deleteData("Tb_Set_Item", where),
              deleteData("WH_ITEM_STC", where),
              deleteData("WH_ITEM_Onhand", where),
            ]);
          }

          setRows((prev) =>
            prev.filter((r) => !selectedRowKeys.includes(getRowKey(r))),
          );
          setSelectedRowKeys([]);
          await onDataChanged?.();
        } catch (e) {
          console.error(e);
          getAlert("FAILED", "ไม่สามารถลบข้อมูลได้");
        }
      });
    } catch (e) {
      console.error(e);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการตรวจสอบข้อมูล");
    }
  };

  const selectOnFocus = (e) => {
    setTimeout(() => e?.target?.select?.(), 0);
  };

  const handleDeleteRow = async (record) => {
    if (record.Item_Id && undeletableItemIds.has(String(record.Item_Id))) {
      getAlert(
        "WARNING",
        "ไม่สามารถลบสินค้าได้ เนื่องจากมีการเคลื่อนไหวสต็อกแล้ว",
      );
      return;
    }
    if (!record.Item_Id) {
      setRows((prev) => {
        const remaining = prev.filter((r) => r.key !== record.key);
        if (remaining.length === 0) {
          setTimeout(() => {
            setOpen(false);
          }, 100);
        }

        return remaining;
      });
      return;
    }
    const confirmMessage = `คุณต้องการลบรายการ\n"${record.Item_Name}"\nใช่หรือไม่?`;
    getAlert("C_DIALOG_MULTILINE", confirmMessage, async (ok) => {
      if (!ok) return;

      try {
        setIsLoading(true);

        const result = await deleteItem(record, { silent: true });

        if (result.cannotDelete.length > 0) {
          getAlert("WARNING_LIST", {
            title: "ไม่สามารถลบสินค้าได้ เนื่องจากมีการเคลื่อนไหวสต็อกแล้ว",
            items: result.cannotDelete.map((r) => ({
              code: r.Item_Code,
              name: r.Item_Name,
            })),
          });
          return;
        }

        setRows((prev) => {
          const remaining = prev.filter((r) => r.key !== record.key);
          if (remaining.length === 0) {
            setTimeout(() => {
              setOpen(false);
              onDataChanged?.(); // รีเฟรชข้อมูล
            }, 100);
          }

          return remaining;
        });
        await onDataChanged?.();
      } catch (err) {
        console.error("handleDeleteRow error:", err);
        getAlert("FAILED", "ไม่สามารถลบรายการได้");
      } finally {
        setIsLoading(false);
      }
    });
  };

  const submitAll = async () => {
    const confirmMsg =
      mode === "create"
        ? "คุณต้องการสร้างสินค้าใหม่หรือไม่?"
        : "คุณต้องการบันทึกการเปลี่ยนแปลงหรือไม่?";

    const handleDuplicate = (res) => {
      const conflicts = res?.conflicts || [];
      setDupInfo({ open: true, conflicts });

      const keys = new Set(
        conflicts.map((x) =>
          String(x.Item_Code || x.Item_Barcode || x.Item_Id || ""),
        ),
      );
      setDupKeys(keys);
    };

    // helper: validate ก่อนยิงจริง
    const validateBeforeSubmit = () => {
      // ---------- CREATE: บังคับฟิลด์สำคัญ ----------
      if (mode === "create") {
        if (!data.Item_Group) {
          getAlert("FAILED", "กรุณาเลือกหมวดหมู่สินค้า");
          return false;
        }
        if (!String(data.Item_Unit_IN || "").trim()) {
          getAlert("FAILED", "กรุณาเลือกหน่วย");
          return false;
        }
        if (!String(data.Item_Name || "").trim()) {
          getAlert("FAILED", "กรุณากรอกชื่อสินค้า (ไทย)");
          return false;
        }
      }

      const allRows = Array.isArray(rows) ? rows : [];
      const activeRows = allRows.filter((r) => !r?.__deleted);

      // ---------- EDIT: กันเคสลบหมด/rows หาย ----------
      if (mode === "edit") {
        if (activeRows.length === 0) {
          // ❗ แนะนำ: ไม่อนุญาตให้ลบหมดใน edit เพื่อกันพลาด
          getAlert(
            "FAILED",
            "ไม่พบรายการสินค้าในตาราง (โหมดแก้ไขไม่อนุญาตให้ลบทั้งหมด)",
          );
          return false;
        }
      }

      // ---------- CREATE: ถ้าไม่เลือกสี/ไซส์เลยแล้วไม่มีแถว ก็ block ----------
      if (mode === "create" && activeRows.length === 0) {
        getAlert("FAILED", "ไม่พบรายการสินค้าในตาราง (กรุณาเลือกสี/ไซส์)");
        return false;
      }

      // ---------- กันแถวที่ code ว่าง ----------
      const missing = activeRows.find(
        (r) => !String(r?.Item_Code || r?.Item_Barcode || "").trim(),
      );
      if (missing) {
        getAlert("FAILED", "บางรายการไม่มีรหัสสินค้า (Item_Code)");
        return false;
      }

      return true;
    };

    if (!validateBeforeSubmit()) return;

    getAlert("C_DIALOG", confirmMsg, async (ok) => {
      if (!ok) return;

      setIsLoading(true);
      try {
        // ======================
        // CREATE MODE
        // ======================
        if (mode === "create") {
          console.debug("rows ::::", rows);

          const payload = {
            mode,
            header: buildHeader(
              data,
              itemBaseCode,
              whIds,
              initQty,
              itemBaseCode,
            ),
            details: (rows || [])
              .filter((r) => !r.__deleted)
              .map((r) => mapRowToDetail(r, whIds)),
          };
          // console.debug("payload", payload);
          const res = await submitItems(payload);

          if (res?.ok === false && res?.errorCode === "DUPLICATE") {
            handleDuplicate(res);
            return;
          }
          if (res?.ok === false) return;

          setOpen(false);
          await onDataChanged?.();
          return;
        }

        // ======================
        // EDIT MODE
        // ======================
        if (mode === "edit") {
          const original = originalHeaderDataRef.current || {};
          const changes = {};

          if (
            String(data.Item_Name || "").trim() !==
            String(original.Item_Name || "").trim()
          ) {
            changes.Item_Name = String(data.Item_Name || "").trim();
          }
          if (
            String(data.Item_Brand || "").trim() !==
            String(original.Item_Brand || "").trim()
          ) {
            changes.Item_Brand = String(data.Item_Brand || "").trim();
          }
          if (
            String(data.Item_Series || "").trim() !==
            String(original.Item_Series || "").trim()
          ) {
            changes.Item_Series = String(data.Item_Series || "").trim();
          }
          if (
            String(data.Item_Group || "") !== String(original.Item_Group || "")
          ) {
            changes.Item_Group = String(data.Item_Group || "");
          }

          if (Object.keys(changes).length > 0 && itemBaseCode) {
            const affectedItems = await getItemsByCodeMaster(itemBaseCode);
            const currentIds = new Set(
              rows.filter((r) => !r.__deleted).map((r) => r.Item_Id),
            );
            const otherItems = affectedItems.filter(
              (item) => !currentIds.has(item.Item_Id),
            );

            if (otherItems.length > 0) {
              setBulkUpdateInfo({
                open: true,
                changes,
                affectedItems: otherItems,
              });
              setIsLoading(false);
              return;
            }
          }

          const { toInsert, toUpdate, toDelete } = splitChanges(rows);
          let canDelete = [];
          let cannotDelete = [];

          if (toDelete.length > 0) {
            const check = await deleteItems(toDelete, { checkOnly: true });
            canDelete = check?.canDelete || [];
            cannotDelete = check?.cannotDelete || [];

            // ถ้ามีรายการที่ลบไม่ได้
            if (cannotDelete.length > 0) {
              // กรณีลบไม่ได้ทั้งหมด
              if (canDelete.length === 0) {
                getAlert(
                  "WARNING_LIST",
                  {
                    title:
                      "ไม่สามารถลบสินค้าได้ เนื่องจากมีการเคลื่อนไหวสต็อกแล้ว",
                    items: cannotDelete.map((r) => ({
                      code: r.Item_Code,
                      name: r.Item_Name,
                    })),
                  },
                  async () => {
                    // ปิด modal + รีเฟรช
                    setOpen(false);
                    await onDataChanged?.();
                  },
                );
                return;
              }

              getAlert(
                "WARNING_LIST",
                {
                  title:
                    "มีสินค้าบางรายการไม่สามารถลบได้ เนื่องจากมีการเคลื่อนไหวสต็อกแล้ว",
                  items: cannotDelete.map((r) => ({
                    code: r.Item_Code,
                    name: r.Item_Name,
                  })),
                },
                async () => {},
              );
            }
          }

          if (canDelete.length > 0) {
            await deleteItems(canDelete, { silent: true });
          }

          if (toUpdate.length > 0) {
            await updateItems(toUpdate);
          }

          if (toInsert.length > 0) {
            const whForEdit = initialData?.header?.WH_Ids ?? whIds ?? [];
            const payload = {
              mode: "create",
              header: buildHeader(
                data,
                data.Item_Name,
                whForEdit,
                initQty,
                itemBaseCode,
              ),
              details: toInsert.map((r) => mapRowToDetail(r, whForEdit)),
            };

            const res = await submitItems(payload);

            if (res?.ok === false && res?.errorCode === "DUPLICATE") {
              handleDuplicate(res);
              return;
            }
            if (res?.ok === false) return;
          }

          setOpen(false);
          await onDataChanged?.();
          return;
        }
      } catch (e) {
        console.error(e);
        getAlert("FAILED", "บันทึกไม่สำเร็จ");
      } finally {
        setIsLoading(false);
      }
    });
  };

  /* =========================================================
   * 0) DYNAMIC TABLE HEIGHT (ResizeObserver)
   * =======================================================*/
  useEffect(() => {
    if (!isOpen || !tableWrapRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { height } = entry.contentRect;
        // Reserve space for table header (~55px) and pagination (~60px)
        const availableHeight = height - 115;
        setScrollY(Math.max(200, availableHeight));
      }
    });

    observer.observe(tableWrapRef.current);
    return () => observer.disconnect();
  }, [isOpen]);

  /* =========================================================
   * 1) LOAD MASTER DATA (groups / units / wh / colours / sizes)
   * =======================================================*/
  const [isMasterLoading, setIsMasterLoading] = useState(false);
  useEffect(() => {
    if (!isOpen) return;

    (async () => {
      setIsMasterLoading(true);
      try {
        const [g, u, w, c, s] = await Promise.all([
          getDataWithComp("Tb_Set_ItmGroup", "AND Group_Status='Y'"),
          getDataWithComp("Tb_Set_Unit", "AND Unit_Status='Y'"),
          getDataWithComp("Tb_Set_WH", "AND WH_Status='Y'"),
          getDataWithComp("Tb_Set_ItmColour", "AND Colour_Status='Y'"),
          getDataWithComp("Tb_Set_ItmSize", "AND Size_Status='Y'"),
        ]);

        setGroups(mapGroups(g || []));
        setUnits(mapUnits(u || []));
        setWarehouses(mapWarehouses(w || []));
        setColours(mapColours(c || []));
        setSizes(mapSizes(s || []));
      } catch (e) {
        console.error(e);
      } finally {
        setIsMasterLoading(false);
      }
    })();
  }, [isOpen]);

  // ฟังก์ชันรีเฟรชข้อมูล
  const refreshUnits = async () => {
    const u = await getDataWithComp("Tb_Set_Unit", "AND Unit_Status='Y'");
    setUnits(mapUnits(u || []));
  };

  const refreshGroups = async (callback) => {
    const g = await getDataWithComp("Tb_Set_ItmGroup", "AND Group_Status='Y'");
    const mappedGroups = mapGroups(g || []);

    // ✅ Use React's setState updater function to ensure state is set before callback
    setGroups((prev) => {
      // Schedule callback after state update
      if (callback) {
        setTimeout(() => callback(mappedGroups), 50);
      }
      return mappedGroups;
    });
  };

  const refreshColours = async () => {
    const c = await getDataWithComp(
      "Tb_Set_ItmColour",
      "AND Colour_Status='Y'",
    );
    setColours(mapColours(c || []));
  };

  /* =========================================================
   * 2) INIT MODAL (CREATE / EDIT)
   *    - EDIT = โหลดเฉพาะ "กลุ่มที่กด"
   *    - ✅ ตรวจสอบรายการที่ลบไม่ได้ทันที
   * =======================================================*/
  useEffect(() => {
    if (!isOpen) return;

    /* ================= CREATE ================= */
    if (mode === "create") {
      setRows([]);
      setSelectedRowKeys([]);
      focusKeyRef.current = null;
      origRowsRef.current = [];
      shortNameDirtyRef.current = false;
      unitDirtyRef.current = false;
      setUndeletableItemIds(new Set());

      setSelColourIds([]);
      setSelSizeIds([]);

      setData({
        Item_Group: "",
        Item_Short_Name: "",
        Item_Name: "",
        Item_Name_EN: "",
        Item_Unit_IN: "",
        Item_Brand: "",
        Item_Series: "",
        Item_Cost: "",
        Item_Price: "",
        Item_PriceA: "",
        Item_PriceB: "",
        is_active: "Y",
        Item_Status: "Y",
      });

      setInitQty("");
      setWhIds([]);
      baseCodeDirtyRef.current = false;
      setItemBaseCode("");

      return;
    }

    /* ================= EDIT ================= */
    if (mode !== "edit" || !initialData) return;

    (async () => {
      setIsLoading(true);

      try {
        /* ---------- header ---------- */
        const baseName = initialData.header?.Item_Short_Name ?? "";

        setData({
          Item_Group: initialData.header?.Item_Group ?? "",
          Item_Short_Name: initialData.header?.Item_Short_Name ?? "",
          Item_Name: baseName,
          Item_Name_EN: initialData.header?.Item_Name_EN ?? "",
          Item_Unit_IN: initialData.header?.Item_Unit_IN ?? "",
          Item_Brand: initialData.header?.Item_Brand ?? "",
          Item_Series: initialData.header?.Item_Series ?? "",
          Item_Cost: initialData.header?.Item_Cost ?? "",
          Item_Price: initialData.header?.Item_Price ?? "",
          Item_PriceA: initialData.header?.Item_PriceA ?? "",
          Item_PriceB: initialData.header?.Item_PriceB ?? "",
          is_active:
            initialData.header?.is_Active ??
            initialData.header?.Is_Active ??
            initialData.header?.Item_Status ??
            "Y",
          Item_Status:
            initialData.header?.is_Active ??
            initialData.header?.Is_Active ??
            initialData.header?.Item_Status ??
            "Y",
        });
        originalHeaderDataRef.current = {
          Item_Name: baseName,
          Item_Brand: initialData.header?.Item_Brand ?? "",
          Item_Series: initialData.header?.Item_Series ?? "",
          Item_Group: initialData.header?.Item_Group ?? "",
        };

        setWhIds(initialData.header?.WH_Ids || []);
        setInitQty(initialData.header?.Init_Qty_All ?? "");

        const dets = initialData.details || [];
        const rawFk = String(initialData.__focusKey ?? "");

        const found = dets.find(
          (d) =>
            String(d.Item_Id) === rawFk ||
            String(d.Item_Code) === rawFk ||
            String(d.Item_Barcode) === rawFk,
        );

        focusKeyRef.current = found
          ? String(found.Item_Id ?? found.Item_Code ?? found.Item_Barcode)
          : rawFk;

        // ✅ Use Item_Code_Master to group products instead of extracting base name
        // This is more reliable and works correctly with all size types including 'ไม่ระบุไซส์'
        const codeMasterToFind =
          found?.Item_Code_Master || initialData.header?.Item_Code_Master || "";

        // Filter by Item_Code_Master if available, otherwise use all details
        const scoped = codeMasterToFind
          ? dets.filter(
              (d) =>
                String(d.Item_Code_Master || "") === String(codeMasterToFind),
            )
          : dets;
        const seenNames = new Set();
        const getSizeLine = (row) => {
          const sizeVal = row.Item_Size ?? row.Size ?? "";
          const found = sizes.find(
            (s) => s.code === sizeVal || s.name === sizeVal,
          );
          const lineValue = found?.line ?? 999;
          return lineValue;
        };

        const uniqueScoped = scoped
          .filter((d) => {
            const key = normalizeName(d.Item_Name);
            if (seenNames.has(key)) return false;
            seenNames.add(key);
            return true;
          })
          .sort((a, b) => {
            const getBaseName = (fullName) => {
              let base = fullName;
              base = base.replace(/\s+สี[^\s]+/g, "");
              base = base.replace(
                /\s+(ไซต์\s*)?([SMLX]{1,3}|[0-9]{1,2}XL|[0-9]+|[A-Z]{1,2}S?)\s*$/g,
                "",
              );
              return base.trim();
            };

            const nameA = getBaseName((a.Item_Name || "").toString().trim());
            const nameB = getBaseName((b.Item_Name || "").toString().trim());
            const nameCompare = nameA.localeCompare(nameB, "th", {
              sensitivity: "base",
            });
            if (nameCompare !== 0) return nameCompare;

            const brandA = (a.Brand || a.Item_Brand || "").toString().trim();
            const brandB = (b.Brand || b.Item_Brand || "").toString().trim();
            const brandCompare = brandA.localeCompare(brandB, "th", {
              sensitivity: "base",
            });

            if (brandCompare !== 0) return brandCompare;

            const seriesA = (a.Series || a.Item_Series || "").toString().trim();
            const seriesB = (b.Series || b.Item_Series || "").toString().trim();
            const seriesCompare = seriesA.localeCompare(seriesB, "th", {
              sensitivity: "base",
            });
            if (seriesCompare !== 0) return seriesCompare;

            const colourA = (a.Colour || a.Item_Colour || "").toString().trim();
            const colourB = (b.Colour || b.Item_Colour || "").toString().trim();
            const colourCompare = colourA.localeCompare(colourB, "th", {
              sensitivity: "base",
            });
            if (colourCompare !== 0) return colourCompare;

            const lineA = getSizeLine(a);
            const lineB = getSizeLine(b);
            const result = lineA - lineB;
            return result;
          });
        const itemIds = uniqueScoped
          .map((d) => d.Item_Id)
          .filter((id) => id != null && id !== undefined);

        const result = await deleteItems(
          itemIds.map((id) => ({ Item_Id: id })),
          { checkOnly: true, silent: true },
        );

        const cannotDeleteIds = new Set(
          result.cannotDelete.map((r) => String(r.Item_Id)),
        );
        setUndeletableItemIds(cannotDeleteIds);

        const mappedRows = uniqueScoped.map((d, i) => {
          const sizeCode = d.Item_Size ?? d.Size ?? "";
          const sizeObj = sizes.find(
            (s) => s.code === sizeCode || s.name === sizeCode,
          );
          const sizeName = sizeObj?.name;

          return {
            ...d,
            Item_Id: d.Item_Id ?? null,
            key: String(d.Item_Id ?? d.Item_Code ?? d.Item_Barcode ?? i),
            __deleted: false,
            Price1: Number(d.Price1 ?? d.Item_Price ?? 0),
            Price2: Number(d.Price2 ?? d.Item_PriceA ?? 0),
            Price3: Number(d.Price3 ?? d.Item_PriceB ?? 0),
            Item_Unit_IN: d.Unit ?? d.Item_Unit_IN ?? "",
            Size: sizeName,
            Size_Name: sizeName,
          };
        });

        setRows(mappedRows);
        setSelectedRowKeys([]);
        origRowsRef.current = scoped.map((x) => ({ ...x }));
        shortNameDirtyRef.current = false;
        unitDirtyRef.current = false;
        baseCodeDirtyRef.current = false;

        if (mode === "edit" && uniqueScoped.length > 0) {
          const firstRow = uniqueScoped[0];
          if (firstRow.Item_Code_Master) {
            setItemBaseCode(String(firstRow.Item_Code_Master).trim());
          } else {
            setItemBaseCode(firstRow.Item_Code_Master);
          }
        } else if (mode === "create") {
          setItemBaseCode("");
        }
      } catch (err) {
        console.error("useEffect [EDIT] error:", err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [isOpen, mode, initialData, sizes]);

  /* =========================================================
   * 3) STATUS -> rows
   * =======================================================*/
  useEffect(() => {
    const yn = data.is_active || data.Item_Status || "Y";
    setRows((prev) =>
      prev.map((r) => ({
        ...r,
        StatusYN: yn,
        Status: yn === "Y" ? "Active" : "In-Active",
      })),
    );
  }, [data.is_active, data.Item_Status]);

  /* =========================================================
   * 4) (EDIT) ดึง ids ของสี/ไซส์จาก details -> selColourIds/selSizeIds
   * =======================================================*/
  useEffect(() => {
    if (!isOpen || mode !== "edit" || !initialData) return;
    if (!colours.length && !sizes.length) return;

    const dets = initialData.details || [];
    const cIds = Array.from(
      new Set(
        dets
          .map((d) => {
            const val = d.Item_Colour ?? d.Colour ?? "";
            return colours.find((c) => c.name === val || c.code === val)?.id;
          })
          .filter((id) => id != null),
      ),
    );
    const sIds = Array.from(
      new Set(
        dets
          .map((d) => {
            const val = d.Item_Size ?? d.Size ?? "";
            return sizes.find((s) => s.name === val || s.code === val)?.id;
          })
          .filter((id) => id != null),
      ),
    );

    setSelColourIds([]);
    setSelSizeIds([]);

    // จากนั้นค่อย set ตาม initialData
    if (cIds.length) setSelColourIds(cIds);
    if (sIds.length) setSelSizeIds(sIds);
  }, [isOpen, mode, initialData, colours, sizes]);

  /* =========================================================
   * 5) Auto หน่วย และ รหัสสินค้า จาก group
   *    - หน่วยต้องมาจาก Tb_Set_ItmGroup.Unit_Id (ทั้ง create และ edit)
   *    - ✅ itemBaseCode auto-fill เฉพาะ CREATE (ป้องกันเปลี่ยนโดยไม่ตั้งใจใน EDIT)
   * =======================================================*/
  const isMasterReady = groups.length > 0 || units.length > 0;
  useEffect(() => {
    if (!isOpen) return;
    if (!data.Item_Group) return;
    if (!groups.length || !units.length) return;

    const grp = groups.find((g) => String(g.id) === String(data.Item_Group));
    if (!grp) return;

    const grpUnitId =
      grp.Unit_Id ?? grp.unitId ?? grp.unit_id ?? grp.unitID ?? null;

    const unitNameFromGroup =
      grpUnitId != null
        ? units.find((u) => String(u.id) === String(grpUnitId))?.name
        : "";

    const grpCode = (grp.Group_CodeName ?? grp.code ?? grp.Group_Code ?? "")
      .toString()
      .trim();

    if (unitNameFromGroup) {
      setData((prev) => ({
        ...prev,
        Item_Unit_IN: unitNameFromGroup,
      }));
    }

    if (mode === "create" && grpCode) {
      setItemBaseCode(grpCode);
    }
  }, [isOpen, mode, data.Item_Group, groups, units]);

  /* =========================================================
   * 6) (CREATE) auto WH จาก localStorage (WHID)
   * =======================================================*/
  useEffect(() => {
    if (!isOpen) return;
    if (mode !== "create") return;
    if (!warehouses.length) return;

    // ถ้าผู้ใช้เลือกคลังเองแล้ว → ไม่ auto ทับ
    if (whIds.length) return;

    const localWHID =
      localStorage.getItem("WHID") ||
      localStorage.getItem("whId") ||
      localStorage.getItem("WHId") ||
      "";

    const found = warehouses.find((w) => String(w.id) === String(localWHID));

    if (found) {
      setWhIds([found.id]);
    } else {
      // fallback: เลือกทั้งหมด หรือจะเลือกตัวแรกก็ได้ (คงของเดิมไว้)
      setWhIds(warehouses.map((w) => w.id));
    }
  }, [isOpen, mode, warehouses, whIds.length]);

  /* =========================================================
   * 7) (CREATE) preview rows = Cartesian สี × ไซส์
   *    ✅ รองรับกรณีไม่เลือกสี/  (สร้างแถวเดียว)
   *    ✅ แก้ไข: ป้องกันการต่อชื่อสี/ไซส์ซ้ำ (case-insensitive)
   * =======================================================*/
  useEffect(() => {
    if (mode === "edit") return;
    if (!colours.length && !sizes.length && !units.length) return;

    const baseShort = itemBaseCode ? itemBaseCode.toString().trim() : "";

    if (!baseShort) {
      setRows([]);
      setSelectedRowKeys([]);
      return;
    }

    const unitName =
      units.find((u) => String(u.name) === String(data.Item_Unit_IN))?.name ||
      data.Item_Unit_IN ||
      "";

    const colourSet = new Set((selColourIds || []).map((x) => String(x)));
    const sizeSet = new Set((selSizeIds || []).map((x) => String(x)));

    console.debug("🟢 [CREATE] Cartesian product");
    console.debug("  selColourIds:", selColourIds);
    console.debug("  selSizeIds:", selSizeIds);
    console.debug("  colourSet:", Array.from(colourSet));
    console.debug("  sizeSet:", Array.from(sizeSet));

    const cs = selColourIds.length
      ? colours.filter((c) => colourSet.has(String(c.id)))
      : [{ id: "", name: "", code: "" }];

    const ss = selSizeIds.length
      ? sizes.filter((s) => sizeSet.has(String(s.id)))
      : [{ id: "", name: "", code: "" }];

    console.debug(
      "  cs (selected colours):",
      cs.map((c) => `${c.name} (ID:${c.id})`),
    );
    console.debug(
      "  ss (selected sizes):",
      ss.map((s) => `${s.name} (ID:${s.id})`),
    );

    const whText = selectedWarehouseNames.join(", ");
    const init = Number(initQty || 0); // ✅ เก็บค่านี้ไว้

    const out = [];
    let idx = 0;

    const normalizeText = (text) =>
      String(text || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();

    for (const c of cs) {
      for (const s of ss) {
        const colorCode = c.code || "";
        const colorName = c.name || "";
        const sizeCode = s.code || "";
        const sizeName = s.name || "";

        const code = `${baseShort}${colorCode}${sizeCode}`;
        const statusYN = data.is_active || data.Item_Status || "Y";

        const baseName = (data.Item_Name || "").trim();

        // ✅ สร้างชื่อเต็มจาก Item_Name + สี + ไซส์ โดยตรง
        const parts = [baseName];
        if (colorName) parts.push(colorName);
        if (sizeName) parts.push(sizeName);
        const fullItemName = parts.join(" ").trim();

        out.push({
          key: `${code}-${idx++}`,
          Item_Id: null,
          __isNew: true,
          Item_Barcode: code,
          Item_Code: code,
          Colour: colorName,
          Size: sizeName,
          Size_Name: sizeName,
          Item_Name: fullItemName,
          Item_Name_EN: data.Item_Name_EN || "",
          Item_Unit_IN: unitName,
          Brand: data.Item_Brand ?? "",
          Series: data.Item_Series ?? "",
          Cost: Number(data.Item_Cost ?? 0),
          Price1: Number(data.Item_Price ?? 0),
          Price2: Number(data.Item_PriceA ?? 0),
          Price3: Number(data.Item_PriceB ?? 0),
          StatusYN: statusYN,
          Status: statusYN === "Y" ? "Active" : "In-Active",
          InitQty: init, // ✅ เปลี่ยนจาก Init_Qty เป็น InitQty
          WH_Text: whText,
          __deleted: false,
        });
      }
    }

    setRows(out);
    setSelectedRowKeys([]);
  }, [
    mode,
    groups,
    units,
    colours,
    sizes,
    data.Item_Group,
    itemBaseCode,
    data.Item_Unit_IN,
    data.Item_Name,
    data.Item_Name_EN,
    data.Item_Brand,
    data.Item_Series,
    data.Item_Cost,
    data.Item_Price,
    data.Item_PriceA,
    data.Item_PriceB,
    data.Item_Status,
    selColourIds,
    selSizeIds,
    selectedWarehouseNames,
    initQty, // ✅ dependency สำคัญ!
  ]);

  /* =========================================================
   * 8) (EDIT) add variants เมื่อเลือกสี/ไซส์เพิ่ม (ไม่ทับของเดิม)
   *    ✅ FIX: เช็คซ้ำกับ DB ก่อนสร้างแถวใหม่
   * =======================================================*/
  useEffect(() => {
    if (!isOpen) return;
    if (mode !== "edit") return;

    const g = groups.find((x) => String(x.id) === String(data.Item_Group));
    const groupCode = (g?.code || "").toString().trim();

    // ✅ ใช้ Item_Code_Master จาก DB (เก็บไว้ตอนสร้าง)
    // หาแถวแรกที่ไม่ถูกลบ
    const firstRow = rows.find((r) => !r.__deleted);
    let baseShort; // ✅ Declare baseShort variable

    if (firstRow?.Item_Code_Master) {
      // ✅ กรณีมี Item_Code_Master → ใช้เลย (ถูกต้อง 100%)
      baseShort = String(firstRow.Item_Code_Master).trim();
    } else if (firstRow?.Item_Code) {
      // ⚠️ Fallback: ใช้ Item_Code โดยตรงเป็น base code (ไม่ตัดสี/ไซส์ออก)
      // สำหรับข้อมูลเก่าที่ยังไม่มี Item_Code_Master
      baseShort = String(firstRow.Item_Code).trim();
    }

    // fallback ถ้าหาไม่เจอ
    if (!baseShort) {
      baseShort = data.Item_Short_Name
        ? data.Item_Short_Name.toString().trim()
        : groupCode;
    }

    if (!baseShort) return;

    console.debug("🔵 [EDIT] useEffect add variants triggered");
    console.debug("  selColourIds:", selColourIds);
    console.debug("  selSizeIds:", selSizeIds);
    console.debug("  current rows count:", rows.length);

    // ✅ ถ้ามี rows อยู่แล้ว เช็คว่ามีการเพิ่มสี/ไซส์ใหม่หรือไม่
    if (rows.length > 0) {
      const existingColours = new Set(
        rows
          .filter((r) => !r.__deleted)
          .map((r) => {
            const colourVal = r.Colour || r.Item_Colour || "";
            return colours.find(
              (c) => c.name === colourVal || c.code === colourVal,
            )?.id;
          })
          .filter((id) => id != null)
          .map(String),
      );

      const existingSizes = new Set(
        rows
          .filter((r) => !r.__deleted)
          .map((r) => {
            const sizeVal = r.Size_Name || r.Size || r.Item_Size || "";
            return sizes.find((s) => s.name === sizeVal || s.code === sizeVal)
              ?.id;
          })
          .filter((id) => id != null)
          .map(String),
      );

      const selectedColours = new Set((selColourIds || []).map(String));
      const selectedSizes = new Set((selSizeIds || []).map(String));

      // ✅ FIX: ถ้า existingColours/Sizes ว่างเปล่า (สินค้าไม่เคยมีสี/ไซส์)
      // และตอนนี้มีการเลือกสี/ไซส์ → ควรสร้าง variants ใหม่
      const hasExistingColours = existingColours.size > 0;
      const hasExistingSizes = existingSizes.size > 0;
      const isSelectingColours = selectedColours.size > 0;
      const isSelectingSizes = selectedSizes.size > 0;

      // ถ้าเดิมไม่มีสี แต่ตอนนี้เลือกสี → ถือว่าเป็น "ใหม่"
      // ถ้าเดิมไม่มีไซส์ แต่ตอนนี้เลือกไซส์ → ถือว่าเป็น "ใหม่"
      const hasNewColour =
        (!hasExistingColours && isSelectingColours) ||
        (hasExistingColours &&
          [...selectedColours].some((id) => !existingColours.has(id)));

      const hasNewSize =
        (!hasExistingSizes && isSelectingSizes) ||
        (hasExistingSizes &&
          [...selectedSizes].some((id) => !existingSizes.has(id)));

      console.debug("  existing colours in rows:", Array.from(existingColours));
      console.debug("  existing sizes in rows:", Array.from(existingSizes));
      console.debug("  hasExistingColours:", hasExistingColours);
      console.debug("  hasExistingSizes:", hasExistingSizes);
      console.debug("  isSelectingColours:", isSelectingColours);
      console.debug("  isSelectingSizes:", isSelectingSizes);
      console.debug("  hasNewColour:", hasNewColour);
      console.debug("  hasNewSize:", hasNewSize);

      if (!hasNewColour && !hasNewSize) {
        console.debug("  ➡️ ไม่มีสี/ไซส์ใหม่ → skip (ไม่สร้าง variants)");
        return;
      }
    }
    console.debug("  current rows count:", rows.length);

    // --- helpers ---
    const normalize = (s = "") =>
      String(s).trim().toLowerCase().replace(/\s+/g, " ");

    const variantKey = (baseName, colourName, sizeCode) =>
      `${normalize(baseName)}|${normalize(colourName)}|${normalize(sizeCode)}`;

    // normalize id เป็น string ก่อนกรอง
    const colourSet = new Set((selColourIds || []).map((x) => String(x)));
    const sizeSet = new Set((selSizeIds || []).map((x) => String(x)));

    const cs = selColourIds.length
      ? colours.filter((c) => colourSet.has(String(c.id)))
      : [{ id: "", name: "", code: "" }];

    const ss = selSizeIds.length
      ? sizes.filter((s) => sizeSet.has(String(s.id)))
      : [{ id: "", name: "", code: "" }];

    console.debug(
      "  cs (selected colours):",
      cs.map((c) => `${c.name} (ID:${c.id})`),
    );
    console.debug(
      "  ss (selected sizes):",
      ss.map((s) => `${s.name} (ID:${s.id})`),
    );

    if (selColourIds.length > 0 && cs.length === 0) {
      console.debug(
        "  ⚠️ selColourIds มีค่า แต่ filter ไม่เจอสีใดในระบบ → skip",
      );
      return;
    }
    if (selSizeIds.length > 0 && ss.length === 0) {
      console.debug(
        "  ⚠️ selSizeIds มีค่า แต่ filter ไม่เจอไซส์ใดในระบบ → skip",
      );
      return;
    }

    const whText = warehouses
      .filter((w) => whIds.map(String).includes(String(w.id)))
      .map((x) => x.name)
      .join(", ");

    const baseName =
      initialData?.header?.Item_Short_Name || data.Item_Short_Name || "";

    console.debug("  🚀 About to create variants, baseName:", baseName);

    (async () => {
      const newVariants = [];

      for (const c of cs) {
        for (const s of ss) {
          const code = `${baseShort}${c.code || ""}${s.code || ""}`;
          // const colorName = c.name || "";
          // const sizeName = s.name || "";

          // ✅ สร้างชื่อเต็มสำหรับเช็ค
          // const normalizeText = (text) =>
          //   String(text || "")
          //     .toLowerCase()
          //     .replace(/\s+/g, " ")
          //     .trim();

          // const baseNameLower = baseName;
          // const hasColour =
          //   colorName && baseNameLower.includes(normalizeText(colorName));
          // const hasSize =
          //   sizeName && baseNameLower.includes(normalizeText(sizeName));

          let fullName = baseName;
          if (c.name) fullName += ` ${c.name}`;
          if (s.name) fullName += ` ${s.name}`;
          fullName = fullName.trim();

          newVariants.push({
            code,
            fullName,
            colour: c,
            size: s,
          });
        }
      }

      // ✅ เช็คซ้ำกับ DB แบบ batch
      if (newVariants.length === 0) {
        console.debug("  ⚠️ newVariants is empty, skip");
        return;
      }

      console.debug("  newVariants count:", newVariants.length);
      console.debug(
        "  newVariants:",
        newVariants.map((v) => `${v.code} (${v.colour.name}/${v.size.name})`),
      );

      // const compId = window.localStorage.getItem("company");
      const codes = newVariants.map((v) => v.code);
      const names = newVariants.map((v) => v.fullName);

      const q = (s) => `'${String(s ?? "").replaceAll("'", "''")}'`;

      const duplicateCheck = await getDataWithComp(
        "Tb_Set_Item",
        `AND (Item_Code IN (${codes.map(q).join(",")}) OR Item_Name IN (${names
          .map(q)
          .join(",")}))`,
      );

      const existingCodes = new Set(
        (duplicateCheck || []).map((r) => String(r.Item_Code || "")),
      );
      const existingNames = new Set(
        (duplicateCheck || []).map((r) => normalize(r.Item_Name || "")),
      );

      setRows((prev) => {
        const existingRowCodes = new Set(
          prev
            .filter((r) => !r.__deleted)
            .map((r) => String(r.Item_Code || r.Item_Barcode || "")),
        );

        const existingRowKeys = new Set(
          prev
            .filter((r) => !r.__deleted)
            .map((r) =>
              variantKey(
                baseName,
                r.Colour || r.Item_Colour || "",
                r.Size_Name || r.Size || r.Item_Size || "",
              ),
            ),
        );

        // console.debug("  existing row codes:", Array.from(existingRowCodes));
        // console.debug("  existing row keys:", Array.from(existingRowKeys));

        const toAdd = [];
        let idx = prev.length;

        for (const variant of newVariants) {
          const vKey = variantKey(
            baseName,
            variant.colour.name || "",
            variant.size.name || "",
          );

          const isDupCode = existingCodes.has(variant.code);
          const isDupName = existingNames.has(normalize(variant.fullName));
          const isDupRowCode = existingRowCodes.has(variant.code);
          const isDupRowKey = existingRowKeys.has(vKey);

          // console.debug(
          //   `    checking: ${variant.code} (${variant.colour.name}/${variant.size.name})`
          // );
          // console.debug(`      vKey: "${vKey}"`);
          // console.debug(
          //   `      dup? DB-code:${isDupCode} DB-name:${isDupName} row-code:${isDupRowCode} row-key:${isDupRowKey}`
          // );

          if (isDupCode || isDupName || isDupRowCode || isDupRowKey) {
            console.debug(`      → SKIP (duplicate)`);
            continue; // ข้ามไม่สร้าง
          }

          console.debug(`      → ADD`);

          // ✅ ไม่ซ้ำ สร้างแถวใหม่
          toAdd.push(
            buildVariantRow({
              baseShort,
              colour: variant.colour,
              size: variant.size,
              idx: idx++,
              whText,
            }),
          );

          existingRowCodes.add(variant.code);
          existingRowKeys.add(vKey);
        }

        console.debug("  ✅ toAdd count:", toAdd.length);

        return toAdd.length ? [...prev, ...toAdd] : prev;
      });
    })();
  }, [
    isOpen,
    mode,
    data.Item_Group,
    data.Item_Short_Name,
    data.Item_Name,
    selColourIds,
    selSizeIds,
    groups,
    colours,
    sizes,
    whIds,
    warehouses,
  ]);

  /* =========================================================
   * 8.5) ลบแถวเมื่อยกเลิกการเลือกสี/ไซส์
   * =======================================================*/
  useEffect(() => {
    if (!isOpen) return;
    if (mode === "edit") return; // ✅ เพิ่มบรรทัดนี้กันลบตอนโหมดแก้ไข

    setRows((prev) => {
      return prev.map((r) => {
        if (r.__deleted) return r;

        const rowColour = r.Colour || r.Item_Colour || "";
        const rowSize = r.Size || r.Item_Size || "";

        const rowColourId = colours.find(
          (c) => c.name === rowColour || c.code === rowColour,
        )?.id;
        const rowSizeId = sizes.find(
          (s) => s.name === rowSize || s.code === rowSize,
        )?.id;

        if (rowColour && rowColourId && !selColourIds.includes(rowColourId)) {
          return { ...r, __deleted: true };
        }
        if (rowSize && rowSizeId && !selSizeIds.includes(rowSizeId)) {
          return { ...r, __deleted: true };
        }
        return r;
      });
    });
  }, [isOpen, mode, selColourIds, selSizeIds, colours, sizes]);

  /* =========================================================
   * 9) (EDIT) sync header fields -> rows (ที่ไม่ถูกลบ)
   *    ✅ FIX: อย่าทับ Item_Name (ทำให้ชื่อเต็มหาย/กันซ้ำพัง)
   *    ✅ อัปเดต Item_Code เมื่อ itemBaseCode เปลี่ยน
   * =======================================================*/
  useEffect(() => {
    if (!isOpen || mode !== "edit") return;

    setRows((prev) =>
      prev.map((r) => {
        if (r.__deleted) return r;

        // ✅ สร้างรหัสใหม่จาก itemBaseCode + color + size
        const colorCode =
          colours.find((c) => c.name === (r.Colour || r.Item_Colour || ""))
            ?.code || "";

        const sizeCode =
          sizes.find(
            (s) =>
              s.name === (r.Size_Name || r.Size || r.Item_Size || "") ||
              s.code === (r.Size || r.Item_Size || ""),
          )?.code || "";

        const newCode = itemBaseCode
          ? `${itemBaseCode}${colorCode}${sizeCode}`
          : r.Item_Code;

        return {
          ...r,
          Item_Code: newCode,
          Item_Barcode: newCode,
          // ✅ ไม่ทับ Item_Name_EN ของแถวใหม่ (Item_Id === null)
          Item_Name_EN: r.Item_Id === null ? r.Item_Name_EN : data.Item_Name_EN,
          Item_Unit_IN: data.Item_Unit_IN,
          Cost: Number(data.Item_Cost ?? 0),
          // Price1/2/3 ไม่ sync อัตโนมัติ (คุณใช้ modal ยืนยันอยู่แล้ว)
          // Brand/Series/Status ยัง sync ได้ตามเดิม
          Brand: data.Item_Brand ?? "",
          Series: data.Item_Series ?? "",
          StatusYN: data.Item_Status ?? "Y",
        };
      }),
    );
  }, [
    isOpen,
    mode,
    itemBaseCode, // ✅ เพิ่ม dependency
    data.Item_Name_EN,
    data.Item_Unit_IN,
    data.Item_Cost,
    data.Item_Brand,
    data.Item_Series,
    data.Item_Status,
    colours, // ✅ เพิ่มเพื่อหา color code
    sizes, // ✅ เพิ่มเพื่อหา size code
  ]);

  useEffect(() => {
    if (!isOpen || mode !== "edit") return;

    const base = String(data.Item_Name ?? "").trim();
    setRows((prev) =>
      prev.map((r) => {
        if (r.__deleted || r.__isNew) return r;

        const colour = r.Colour ?? r.Item_Colour ?? "";
        const size = r.Size ?? r.Item_Size ?? "";
        const parts = [base];
        if (colour) parts.push(colour);
        if (size) parts.push(size);

        return { ...r, Item_Name: parts.join(" ").trim() };
      }),
    );
  }, [isOpen, mode, data.Item_Name]);

  if (!isOpen) return null;

  return (
    <div className="pm-overlay" role="diadebug" aria-modal="true">
      <Spin
        spinning={isMasterLoading}
        // tip={isMasterLoading ? "กำลังโหลดข้อมูล..." : "กำลังดำเนินการ..."}
        fullscreen
      />
      <div className="pm-modal">
        {/* HEADER */}
        <div className="pm-header">
          <div className="pm-title">
            {mode === "create" ? "สร้างสินค้าใหม่" : "แก้ไขสินค้า"}
          </div>
          <button className="pm-close" onClick={onClose} aria-label="close">
            ×
          </button>
        </div>

        {/* BODY */}
        <div className="pm-body">
          <div className="pm-form pm-form--create">
            {/* ============ LEFT (หมวด/หน่วย/รหัส + ชื่อไทย/ยี่ห้อ/รุ่น) ============ */}
            <div className="pm-left">
              {/* ซ้ายย่อย: หมวด/หน่วย/รหัส */}
              <div className="pm-left-col">
                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    หมวดหมู่สินค้า <span style={{ color: "red" }}>*</span>
                  </label>
                  <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                    <SmartSelect
                      className="w-100"
                      style={{ flex: 1 }}
                      allowClear
                      placeholder="เลือกหมวดหมู่"
                      value={String(data.Item_Group || "")}
                      onChange={(v) =>
                        setData((s) => ({
                          ...s,
                          Item_Group:
                            typeof v === "object"
                              ? v?.value != null
                                ? String(v.value)
                                : ""
                              : v != null
                                ? String(v)
                                : "",
                        }))
                      }
                      options={[...groups]
                        .sort((a, b) =>
                          a.name.localeCompare(b.name, "th", {
                            numeric: true,
                            sensitivity: "base",
                          }),
                        )
                        .map((g) => ({
                          label: g.name,
                          value: String(g.id),
                        }))}
                      maxRender={120}
                      debounceMs={180}
                    />
                    <button
                      type="button"
                      onClick={() => setShowAddCategoryUnitModal(true)}
                      style={{
                        minWidth: 36,
                        height: 36,
                        borderRadius: 6,
                        background: "#28a745",
                        color: "white",
                        border: "none",
                        fontSize: 20,
                        fontWeight: "bold",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s",
                        flexShrink: 0,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#218838";
                        e.currentTarget.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#28a745";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    >
                      <PlusOutlined />
                    </button>
                  </div>
                </div>

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    หน่วย<span style={{ color: "red" }}>*</span>
                  </label>
                  <SmartSelect
                    className="w-100"
                    allowClear
                    placeholder="เลือกหน่วยนับ"
                    value={data.Item_Unit_IN}
                    onChange={(v) => {
                      unitDirtyRef.current = true;
                      setData((s) => ({
                        ...s,
                        Item_Unit_IN: v?.value ?? v?.label ?? "",
                      }));
                    }}
                    options={units
                      .sort((a, b) => a.name.localeCompare(b.name, "th"))
                      .map((u) => ({
                        label: u.name,
                        value: u.name,
                        id: u.id,
                      }))}
                    maxRender={120}
                    debounceMs={180}
                    returnObject
                  />
                </div>
                {mode === "edit" ? (
                  <div className="pm-col">
                    <label
                      className="label-modal"
                      style={{
                        width: "90px",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      {/* รหัสสินค้า<span style={{ color: "red" }}>*</span> */}
                    </label>
                    {/* <input
                      name="itemBaseCode"
                      value={itemBaseCode}
                      onChange={(e) => {
                        baseCodeDirtyRef.current = true;
                        setItemBaseCode(e.target.value);
                      }}
                      disabled={mode === "edit"}
                      placeholder="รหัสสินค้าตั้งต้น"
                    /> */}
                  </div>
                ) : (
                  <div className="pm-col">
                    <label
                      className="label-modal"
                      style={{
                        width: "90px",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      รหัสสินค้า<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      name="itemBaseCode"
                      value={itemBaseCode}
                      onChange={(e) => {
                        baseCodeDirtyRef.current = true;
                        setItemBaseCode(e.target.value);
                      }}
                      disabled={mode === "edit"}
                      placeholder="รหัสสินค้าตั้งต้น"
                    />
                  </div>
                )}
              </div>

              {/* ขวาย่อย: ชื่อไทย/ยี่ห้อ/รุ่น */}
              <div className="pm-left-col">
                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ชื่อสินค้า (ไทย) <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="Item_Name"
                    value={data.Item_Name}
                    onChange={handleChange}
                  />
                </div>

                

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ยี่ห้อ
                  </label>
                  <input
                    name="Item_Brand"
                    value={data.Item_Brand}
                    onChange={handleChange}
                    placeholder="ยี่ห้อ"
                  />
                </div>

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    รุ่น
                  </label>
                  <input
                    name="Item_Series"
                    value={data.Item_Series}
                    onChange={handleChange}
                    placeholder="รุ่น"
                  />
                </div>
              </div>
            </div>

            {/* ============ PICKERS (เลือกสี / เลือกไซส์) ============ */}
            <div className="pm-pickers">
              <div className="pm-col3">
                <label className="label-modal"></label>
                <div className="pm-picker-row">
                  <button
                    type="button"
                    className="pm-pick-btn"
                    onClick={() => setOpenColourPicker(true)}
                  >
                    เลือกสี
                  </button>

                  {/* ✅ เปลี่ยน inline style เป็น class เพื่อคุม layout */}
                  <div className="pm-chip-wrap">
                    {selectedColourChips.length === 0 ? (
                      <span className="pm-chip empty">ยังไม่เลือก</span>
                    ) : (
                      selectedColourChips.map((t) => {
                        const colour = colours.find((c) => c.name === t);
                        return (
                          <span key={t} className="pm-chip">
                            {t}
                            <button
                              className="pm-chip-remove"
                              onClick={() =>
                                setSelColourIds(
                                  selColourIds.filter((id) => id !== colour.id),
                                )
                              }
                            >
                              ×
                            </button>
                          </span>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>

              <div className="pm-col3">
                <label className="label-modal"></label>
                <div className="pm-picker-row">
                  <button
                    type="button"
                    className="pm-pick-btn"
                    onClick={() => setOpenSizePicker(true)}
                  >
                    เลือกไซส์
                  </button>

                  {/* ✅ เปลี่ยน inline style เป็น class เพื่อคุม layout */}
                  <div className="pm-chip-wrap">
                    {selectedSizeChips.length === 0 ? (
                      <span className="pm-chip empty">ยังไม่เลือก</span>
                    ) : (
                      selectedSizeChips.map((t) => {
                        const size = sizes.find((s) => s.name === t);
                        return (
                          <span key={t} className="pm-chip">
                            {t}
                            <button
                              className="pm-chip-remove"
                              onClick={() =>
                                setSelSizeIds(
                                  selSizeIds.filter((id) => id !== size.id),
                                )
                              }
                            >
                              ×
                            </button>
                          </span>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* ============ RIGHT SIDE (คลัง + ราคา) ============ */}
            <div className="pm-right-wrapper">
              {/* คลัง / จำนวนตั้งต้น */}
              <div className="pm-stock">
                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    คลัง <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    // mode="multiple"
                    allowClear
                    value={whIds[0] || undefined}
                    onChange={(val) => setWhIds(val ? [val] : [])}
                    placeholder="เลือกคลัง"
                    className="pm-ant-select"
                    options={warehouses.map((w) => ({
                      value: w.id,
                      label: w.name,
                    }))}
                    disabled={mode === "edit"}
                  />
                </div>

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    จำนวนตั้งต้น
                  </label>
                  <InputNumber
                    value={initQty === "" ? null : Number(initQty)}
                    onChange={(v) => setInitQty(v ?? "")}
                    formatter={formatterWithCommas}
                    parser={parserStrict}
                    precision={0}
                    inputMode="numeric"
                    onKeyDown={onlyNumberKeyDown}
                    onFocus={selectOnFocus}
                    style={{ width: "100%" }}
                    disabled={mode === "edit"}
                  />
                </div>
                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ใช้งาน
                  </label>
                  <Select
                    className="pm-ant-select"
                    value={data.is_active || "Y"}
                    onChange={(value) =>
                      setData((s) => ({
                        ...s,
                        is_active: value || "Y",
                        Item_Status: value || "Y",
                      }))
                    }
                    options={[
                      { value: "Y", label: "ใช้งาน" },
                      { value: "N", label: "ไม่ใช้งาน" },
                    ]}
                  />
                </div>
              </div>

              {/* ต้นทุน / ราคา 1-3 */}
              <div className="pm-prices">
                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ต้นทุน
                  </label>
                  <InputNumber
                    value={
                      data.Item_Cost === "" ? null : Number(data.Item_Cost)
                    }
                    onChange={(v) =>
                      setData((s) => ({ ...s, Item_Cost: v ?? "" }))
                    }
                    formatter={formatterWithCommas}
                    parser={parserStrict}
                    precision={2}
                    inputMode="decimal"
                    onKeyDown={onlyNumberKeyDown}
                    onFocus={selectOnFocus}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ราคา 1
                  </label>
                  <InputNumber
                    value={
                      data.Item_Price === "" ? null : Number(data.Item_Price)
                    }
                    onChange={(v) =>
                      setData((s) => ({ ...s, Item_Price: v ?? "" }))
                    }
                    onFocus={(e) => {
                      headerPriceBeforeChangeRef.current.Item_Price = Number(
                        data.Item_Price ?? 0,
                      );
                      rowPricesBeforeChangeRef.current = rows
                        .filter((r) => !r.__deleted)
                        .map((r) => ({ key: r.key, value: r.Price1 ?? 0 }));
                      selectOnFocus(e);
                    }}
                    onBlur={(e) => {
                      const inputValue = e.target.value;
                      const newValue = inputValue
                        ? Number(inputValue.replace(/,/g, ""))
                        : 0;
                      handlePriceBlur("Item_Price", newValue);
                    }}
                    formatter={formatterWithCommas}
                    parser={parserStrict}
                    precision={2}
                    inputMode="decimal"
                    onKeyDown={onlyNumberKeyDown}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ราคา 2
                  </label>
                  <InputNumber
                    value={
                      data.Item_PriceA === "" ? null : Number(data.Item_PriceA)
                    }
                    onChange={(v) =>
                      setData((s) => ({ ...s, Item_PriceA: v ?? "" }))
                    }
                    onFocus={(e) => {
                      headerPriceBeforeChangeRef.current.Item_PriceA = Number(
                        data.Item_PriceA ?? 0,
                      );
                      rowPricesBeforeChangeRef.current = rows
                        .filter((r) => !r.__deleted)
                        .map((r) => ({ key: r.key, value: r.Price2 ?? 0 }));
                      selectOnFocus(e);
                    }}
                    onBlur={(e) => {
                      const inputValue = e.target.value;
                      const newValue = inputValue
                        ? Number(inputValue.replace(/,/g, ""))
                        : 0;
                      handlePriceBlur("Item_PriceA", newValue);
                    }}
                    formatter={formatterWithCommas}
                    parser={parserStrict}
                    precision={2}
                    inputMode="decimal"
                    onKeyDown={onlyNumberKeyDown}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="pm-col">
                  <label
                    className="label-modal"
                    style={{
                      width: "90px",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    ราคา 3
                  </label>
                  <InputNumber
                    value={
                      data.Item_PriceB === "" ? null : Number(data.Item_PriceB)
                    }
                    onChange={(v) =>
                      setData((s) => ({ ...s, Item_PriceB: v ?? "" }))
                    }
                    onFocus={(e) => {
                      headerPriceBeforeChangeRef.current.Item_PriceB = Number(
                        data.Item_PriceB ?? 0,
                      );
                      rowPricesBeforeChangeRef.current = rows
                        .filter((r) => !r.__deleted)
                        .map((r) => ({ key: r.key, value: r.Price3 ?? 0 }));
                      selectOnFocus(e);
                    }}
                    onBlur={(e) => {
                      const inputValue = e.target.value;
                      const newValue = inputValue
                        ? Number(inputValue.replace(/,/g, ""))
                        : 0;
                      handlePriceBlur("Item_PriceB", newValue);
                    }}
                    formatter={formatterWithCommas}
                    parser={parserStrict}
                    precision={2}
                    inputMode="decimal"
                    onKeyDown={onlyNumberKeyDown}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* PREVIEW TABLE */}
          <div className="pm-table-wrap" ref={tableWrapRef}>
            <Table
              size="small"
              rowKey="key"
              columns={columns}
              dataSource={rows.filter((r) => !r.__deleted)}
              pagination={{
                pageSize: 50,
                showSizeChanger: true,
                pageSizeOptions: ["60", "80", "100", "200"],
                // showTotal: (total, range) => (
                //   <div
                //     style={{
                //       position: "absolute",
                //       left: 0,
                //       fontSize: "14px",
                //       color: "#666",
                //     }}
                //   >
                //     ทั้งหมด {total} รายการ
                //   </div>
                // ),
                position: ["bottomRight"],
                style: {
                  position: "relative",
                  paddingTop: "8px",
                },
              }}
              bordered
              sticky
              scroll={{ x: totalColumnWidth, y: scrollY }}
              rowClassName={(record) => {
                if (record.__isNew) return "row-new";
                return "";
              }}
              locale={{
                emptyText: (
                  <div style={{ padding: "40px 0", color: "#999" }}>
                    <div style={{ fontSize: "16px", marginBottom: "8px" }}>
                      ไม่พบข้อมูล
                    </div>
                  </div>
                ),
              }}
            />
          </div>
          <div
            style={{
              color: "black",
              padding: "8px 12px",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              justifyContent: "space-between",
            }}
          >
            <span>รายการ : {rows?.length ? rows?.length : 0}</span>
            <span style={{ fontSize: "12px", color: "#666" }}>
              💡 ใช้ลูกศร ↑↓ เปลี่ยนแถว | ←→ เปลี่ยนราคา
            </span>
          </div>
        </div>

        {/* FOOTER (ไม่มีปุ่มย้อนกลับ) */}
        <div className="pm-footer">
          <div className="spacer" />
          {mode === "edit" && selectedRowKeys.length > 0 && (
            <button
              type="button"
              className="pm-del"
              onClick={handleDeleteSelected}
            >
              ลบรายการที่เลือก ({selectedRowKeys.length})
            </button>
          )}
          <button className="pm-save" type="button" onClick={submitAll}>
            บันทึก
          </button>
        </div>
      </div>

      {/* MODALS: เลือกสี/ไซส์ */}
      <OptionPickerModal
        open={openColourPicker}
        title="เลือกสี"
        items={colours}
        selectedIds={selColourIds}
        onChange={setSelColourIds}
        onCancel={() => setOpenColourPicker(false)}
        onOk={() => setOpenColourPicker(false)}
        gridColumns={4}
        onAddNew={() => setShowAddColorModal(true)}
      />
      <OptionPickerModal
        open={openSizePicker}
        title="เลือกไซส์"
        items={sizes}
        selectedIds={selSizeIds}
        onChange={setSelSizeIds}
        onCancel={() => setOpenSizePicker(false)}
        onOk={() => setOpenSizePicker(false)}
        sortByLine={true}
        gridColumns={4}
      />

      {(() => {
        // Field name mapping to Thai
        const fieldMapping = {
          Item_Code: "รหัสสินค้า",
          Item_Barcode: "บาร์โค้ด",
          Item_Name: "ชื่อสินค้า",
          Item_Short_Name: "รหัสย่อ",
          Item_Brand: "ยี่ห้อ",
          Item_Series: "รุ่น",
          Item_Colour: "สี",
          Item_Size: "ขนาด",
        };

        const allConflictFields = new Set();
        (dupInfo.conflicts || []).forEach((conflict) => {
          if (Array.isArray(conflict.conflictFields)) {
            conflict.conflictFields.forEach((field) => {
              if (field !== "Item_Barcode") allConflictFields.add(field); // 👈 ตัดออก
            });
          }
        });

        // Convert to Thai and join
        const thaiConflictFields = Array.from(allConflictFields)
          .map((f) => fieldMapping[f] || f)
          .join(", ");

        const modalTitle = thaiConflictFields
          ? `พบข้อมูล ${thaiConflictFields} ซ้ำ กรุณาแก้ไขก่อนบันทึก`
          : "พบข้อมูลซ้ำ กรุณาแก้ไขก่อนบันทึก";

        const fmtDate = (v) => {
          if (!v) return "-";
          const d = new Date(v);

          const pad = (n) => String(n).padStart(2, "0");

          return (
            pad(d.getUTCDate()) +
            "/" +
            pad(d.getUTCMonth() + 1) +
            "/" +
            d.getUTCFullYear() +
            " " +
            pad(d.getUTCHours()) +
            ":" +
            pad(d.getUTCMinutes())
          );
        };

        const pick = (obj, keys) => {
          for (const k of keys) {
            if (obj?.[k] != null && obj?.[k] !== "") return obj[k];
          }
          return null;
        };

        return (
          <Modal
            open={dupInfo.open}
            title={modalTitle}
            onCancel={() => setDupInfo({ open: false, conflicts: [] })}
            onOk={() => setDupInfo({ open: false, conflicts: [] })}
            okText="ปิด"
            cancelButtonProps={{ style: { display: "none" } }}
            width={1100}
          >
            <Table
              size="small"
              rowKey={(r, i) => r.Item_Id ?? r.Item_Code ?? i}
              pagination={false}
              dataSource={dupInfo.conflicts}
              scroll={{ x: 1000 }}
              columns={[
                { title: "รหัส", dataIndex: "Item_Code", width: 140 },
                { title: "ชื่อสินค้า", dataIndex: "Item_Name", width: 260 },

                {
                  title: "วันที่สร้าง",
                  dataIndex: "Created_Date",
                  width: 160,
                  render: fmtDate,
                },
                {
                  title: "ผู้สร้าง",
                  dataIndex: "Created_By_Name",
                  width: 140,
                  render: (v) => v || "-",
                },
                {
                  title: "วันที่แก้ไข",
                  dataIndex: "Update_Date",
                  width: 160,
                  render: fmtDate,
                },
                {
                  title: "ผู้แก้ไข",
                  dataIndex: "Update_By_Name",
                  width: 140,
                  render: (v) => v || "-",
                },
              ]}
            />
          </Modal>
        );
      })()}

      <Modal
        open={bulkUpdateInfo.open}
        title={(() => {
          const changedFields = [];
          if (bulkUpdateInfo.changes.Item_Group) changedFields.push("หมวดหมู่");
          if (bulkUpdateInfo.changes.Item_Name) changedFields.push("ชื่อ");
          if (bulkUpdateInfo.changes.Item_Brand) changedFields.push("ยี่ห้อ");
          if (bulkUpdateInfo.changes.Item_Series) changedFields.push("รุ่น");
          return `มีการแก้ข้อมูล ${changedFields.join(" ,")}`;
        })()}
        onCancel={() =>
          setBulkUpdateInfo({ open: false, changes: {}, affectedItems: [] })
        }
        width={1000}
        footer={null}
      >
        <div style={{ marginBottom: 16 }}>
          {/* ✅ Before/After Comparison */}
          <div
            style={{
              marginBottom: 16,
              padding: 12,
              background: "#fff7ed",
              borderRadius: 4,
              fontSize: 14,
            }}
          >
            <div style={{ marginBottom: 8 }}>
              <strong>จาก :</strong>{" "}
              <span>
                {(() => {
                  const original = originalHeaderDataRef.current || {};
                  const parts = [];

                  if (bulkUpdateInfo.changes.Item_Group) {
                    const grpName =
                      groups.find(
                        (g) => String(g.id) === String(original.Item_Group),
                      )?.name || "";
                    parts.push(`หมวดหมู่ : ${grpName}`);
                  }
                  if (bulkUpdateInfo.changes.Item_Name) {
                    parts.push(`ชื่อ : ${original.Item_Name || ""}`);
                  }
                  if (bulkUpdateInfo.changes.Item_Brand) {
                    parts.push(`ยี่ห้อ : ${original.Item_Brand || ""}`);
                  }
                  if (bulkUpdateInfo.changes.Item_Series) {
                    parts.push(`รุ่น : ${original.Item_Series || ""}`);
                  }

                  return parts.join("  ");
                })()}
              </span>
            </div>
            <div>
              <strong>ไปเป็น :</strong>{" "}
              <span style={{ color: "#f97316" }}>
                {(() => {
                  const parts = [];

                  if (bulkUpdateInfo.changes.Item_Group) {
                    const grpName =
                      groups.find(
                        (g) =>
                          String(g.id) ===
                          String(bulkUpdateInfo.changes.Item_Group),
                      )?.name || "";
                    parts.push(`หมวดหมู่ : ${grpName}`);
                  }
                  if (bulkUpdateInfo.changes.Item_Name) {
                    parts.push(`ชื่อ : ${bulkUpdateInfo.changes.Item_Name}`);
                  }
                  if (bulkUpdateInfo.changes.Item_Brand) {
                    parts.push(`ยี่ห้อ : ${bulkUpdateInfo.changes.Item_Brand}`);
                  }
                  if (bulkUpdateInfo.changes.Item_Series) {
                    parts.push(`รุ่น : ${bulkUpdateInfo.changes.Item_Series}`);
                  }

                  return parts.join("  ");
                })()}
              </span>
            </div>
          </div>

          {/* ✅ ข้อความเหนือตาราง */}
          <div style={{ marginBottom: 8, fontSize: 14, fontWeight: 500 }}>
            ข้อมูลสินค้าใหม่จะเปลี่ยนแปลงทุกรายการดังนี้
          </div>
        </div>

        <Table
          size="small"
          rowKey="Item_Id"
          pagination={{ pageSize: 10 }}
          dataSource={bulkUpdateInfo.affectedItems}
          scroll={{ y: 400 }}
          columns={[
            { title: "#", width: 50, render: (_, __, i) => i + 1 },
            { title: "รหัส", dataIndex: "Item_Code", width: 140 },
            { title: "ชื่อ", dataIndex: "Item_Name", width: 260 },
            { title: "ยี่ห้อ", dataIndex: "Item_Brand", width: 120 },
            { title: "รุ่น", dataIndex: "Item_Series", width: 120 },
            { title: "สี", dataIndex: "Item_Colour", width: 90 },
            { title: "ไซส์", dataIndex: "Item_Size", width: 90 },
          ]}
        />

        <div
          style={{
            marginTop: 16,
            display: "flex",
            gap: 12,
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() =>
              setBulkUpdateInfo({ open: false, changes: {}, affectedItems: [] })
            }
          >
            ยกเลิก
          </Button>
          <Button
            type="primary"
            onClick={async () => {
              setIsLoading(true);
              setBulkUpdateInfo({
                open: false,
                changes: {},
                affectedItems: [],
              });

              try {
                await bulkUpdateByCodeMaster(
                  bulkUpdateInfo.changes,
                  itemBaseCode,
                  {
                    silent: true,
                  },
                );
                const { toInsert, toUpdate, toDelete } = splitChanges(rows);

                if (toDelete.length > 0) {
                  const check = await deleteItems(toDelete, {
                    checkOnly: true,
                  });
                  const canDelete = check?.canDelete || [];
                  if (canDelete.length > 0) {
                    await deleteItems(canDelete, { silent: true });
                  }
                }

                if (toUpdate.length > 0) {
                  await updateItems(toUpdate);
                }

                if (toInsert.length > 0) {
                  const whForEdit = initialData?.header?.WH_Ids ?? whIds ?? [];
                  const payload = {
                    mode: "create",
                    header: buildHeader(
                      data,
                      data.Item_Name,
                      whForEdit,
                      initQty,
                      itemBaseCode,
                    ),
                    details: toInsert.map((r) => mapRowToDetail(r, whForEdit)),
                  };
                  await submitItems(payload);
                }

                setOpen(false);
                await onDataChanged?.();
              } catch (e) {
                console.error(e);
                getAlert("FAILED", "บันทึกไม่สำเร็จ");
              } finally {
                setIsLoading(false);
              }
            }}
          >
            ยืนยัน
          </Button>
        </div>
      </Modal>

      {/* Modal สำหรับเพิ่มหมวดหมู่และหน่วย */}
      <AddCategoryUnitModal
        open={showAddCategoryUnitModal}
        onClose={() => setShowAddCategoryUnitModal(false)}
        onSuccess={async (type, newId) => {
          if (type === "category") {
            await refreshGroups((freshGroups) => {
              // ✅ Use fresh groups data to ensure the new category exists
              const exists = freshGroups.some(
                (g) => String(g.id) === String(newId),
              );
              if (exists) {
                setData((prev) => ({ ...prev, Item_Group: String(newId) }));
              } else {
                console.warn("New category not found in fresh groups:", newId);
              }
            });
          }
          // หน่วยจะถูก refresh และแสดงใน modal อัตโนมัติ
          setShowAddCategoryUnitModal(false);
        }}
        existingGroups={groups}
        existingUnits={units}
        onUnitsRefresh={refreshUnits}
      />

      {/* Modal สำหรับเพิ่มสี */}
      <AddColorModal
        open={showAddColorModal}
        onClose={() => setShowAddColorModal(false)}
        onSuccess={async (newColorId) => {
          await refreshColours();
          setSelColourIds((prev) => [...prev, newColorId]);
          setShowAddColorModal(false);
        }}
        existingColors={colours}
      />

      <style jsx global>{`
        /* ====== Scrollbar & layout helpers (เดิม) ====== */
        .items-table .ant-table-content,
        .items-table .ant-table-body {
          overflow: auto !important;
          scrollbar-gutter: stable both-edges;
          scrollbar-width: thin;
        }
        .items-table .ant-table-content::-webkit-scrollbar,
        .items-table .ant-table-body::-webkit-scrollbar {
          height: 10px;
          width: 10px;
        }
        .items-table .ant-table-content::-webkit-scrollbar-thumb,
        .items-table .ant-table-body::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.3);
          border-radius: 8px;
        }

        .label-modal {
          width: 150px;
        }
        .label-modal2 {
          width: 30px;
        }
        .ant-table-wrapper .ant-table-thead > tr > th {
          background: linear-gradient(90deg, #f97316, #ef6c00);
          color: #fff;
          font-weight: 600;
        }

        /* ====== แถบสีแถว/โฮเวอร์/เลือก (เดิม) ====== */
        .ant-table-tbody > tr.row-even > td {
          background: #ffffff;
        }
        .ant-table-tbody > tr.row-odd > td {
          background: oklch(0.98 0.01 71.17);
        }
        .ant-table-tbody > tr:hover > td,
        .ant-table-tbody > tr.ant-table-row-selected > td {
          background: oklch(0.91 0.05 60.5) !important;
        }

        /* ====== Compact AntD Table inside ProductModal ====== */
        .pm-table-wrap .ant-table {
          --pm-row-h: 22px; /* ความสูงแถวข้อมูล */
          --pm-head-h: 40px; /* ความสูงหัวตาราง */
          --pm-pad-y: 0px; /* padding แนวตั้ง */
          --pm-pad-x: 0px; /* padding แนวนอน */
          --pm-font: 12px; /* ขนาดตัวอักษร */
        }

        /* คุมที่ cell (ไม่เซ็ต height บน tr เพื่อไม่ชน measure-row) */
        .pm-table-wrap .ant-table-thead > tr > th {
          padding: 8px 8px !important;
          font-size: 13px;
          white-space: nowrap;
          vertical-align: middle;
        }
        /* body */

        /* 🔧 ซ่อนแถววัดขนาด/placeholder ของ AntD ที่ทำให้เหมือนมีแถวแรกแถม */
        .pm-table-wrap .ant-table-tbody > tr.ant-table-measure-row,
        .pm-table-wrap .ant-table-tbody > tr.ant-table-placeholder {
          height: 0 !important;
          line-height: 0 !important;
          font-size: 0 !important;
        }
        .pm-table-wrap .ant-table-tbody > tr.ant-table-measure-row > td,
        .pm-table-wrap .ant-table-tbody > tr.ant-table-placeholder > td {
          padding: 0 !important;
          border: 0 !important;
        }

        /* คุมความสูงคอมโพเนนต์อินพุตในเซลล์ให้พอดีแถว */
        .pm-table-wrap .ant-input-number,
        .pm-table-wrap .ant-input-number input {
          height: calc(var(--pm-row-h) - 2px) !important;
          line-height: calc(var(--pm-row-h) - 2px) !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }
        .pm-table-wrap .ant-input-number-handler-wrap {
          height: 100% !important;
        }

        /* ไอคอนลบให้สมส่วนกับความสูงแถว */
        .pm-del-icon {
          font-size: 14px !important;
          line-height: var(--pm-row-h) !important;
        }

        /* ====== Chips/Buttons/Effect (เดิม) ====== */
        .pm-chip {
          position: relative;
          display: inline-flex;
          align-items: center;
          padding: 3px 0;
          border-radius: 16px;
          background-color: #f2f2f2;
          margin: 4px;
          width: 80px;
          transition: background-color 0.2s ease;
          white-space: nowrap;
          justify-content: center;
        }
        .pm-pick-btn {
          width: 90px;
        }
        .pm-chip-row {
          display: grid;
          grid-template-columns: auto auto auto;
          position: relative;
        }
        .pm-chip-row2 {
          display: grid;
          position: relative;
          gap: 5px;
        }
        .pm-chip:hover {
          background-color: #e0e0e0;
        }
        .pm-chip-remove {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #979191ff;
          color: #fff;
          border: none;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          font-size: 12px;
          cursor: pointer;
          display: none;
        }
        .pm-chip:hover .pm-chip-remove {
          display: block;
        }

        .pm-row-focus > td {
          background: #fff8e1 !important;
        }

        /* แถวที่ซ้ำ */
        .pm-row-dup > td {
          background: #fee2e2 !important; /* แดงอ่อน */
          border-top: 1px solid #fecaca !important;
          border-bottom: 1px solid #fecaca !important;
        }

        @keyframes pmBlink {
          0% {
            box-shadow: inset 0 0 0 0 rgba(239, 108, 0, 0.6);
          }
          50% {
            box-shadow: inset 0 0 0 9999px rgba(239, 108, 0, 0.15);
          }
          100% {
            box-shadow: inset 0 0 0 0 rgba(239, 108, 0, 0);
          }
        }
        .pm-row-blink > td {
          animation: pmBlink 1.2s ease;
        }
      `}</style>
    </div>
  );
}
